import type { TranslationKeys } from './es';

const fr: TranslationKeys = {
  nav: { services: 'Services', about: 'À Propos', blog: 'Blog', zones: 'Zones', contact: 'Contact', login: 'Connexion', clientArea: 'Espace Client', language: 'Langue', home: 'Accueil', access: 'Accéder', search: 'Rechercher sur Punto Hispano', searchPlaceholder: 'Que cherchez-vous ? Ex: assurances, logement...', noResults: 'Aucun résultat pour', tryOther: 'Essayez d\'autres termes', popularSearches: 'Recherches populaires :', quickAccess: 'Accès rapide :', freeConsultation: 'Consultation Gratuite', allZones: 'Toutes les Zones', digitalBusiness: 'Entreprise Digitale', aboutUs: 'À Propos', closeMenu: 'Fermer le menu', openMenu: 'Ouvrir le menu' },
  hero: { title: 'Votre gestion administrative en Suisse', subtitle: 'Gestion, conseil juridique, assurances, langues et solutions digitales pour francophones en Suisse.', cta: 'Consultation Gratuite', ctaSecondary: 'Voir les Services', trustBadge: '+2 500 familles nous font confiance', experience: '+12 ans d\'expérience', act: 'ACTE I', actSubtitle: 'QUI SOMMES-NOUS', titleLine1: 'GESTION &', titleLine2: 'CONSEIL', titleLine3: 'EN SUISSE', cinematicSubtitle: 'Votre pont vers le succès en Suisse. Plus de 12 ans d\'aide aux francophones.', discoverServices: 'Découvrir les Services', scheduleConsultation: 'Prendre Rendez-vous' },
  services: { title: 'Nos Services', subtitle: 'Tout pour vivre sereinement en Suisse', gestoria: { name: 'Gestion Administrative', description: 'Gestion complète : RAV, impôts, permis, CV, traductions.', cta: 'Voir les Services' }, legal: { name: 'Conseil Juridique', description: 'Droit des étrangers, travail, famille, commercial.', cta: 'Conseil Juridique' }, seguros: { name: 'Assurances et Prévoyance', description: 'Assurances maladie, vie, habitation, véhicules.', cta: 'Devis Gratuit' }, idiomas: { name: 'Cours de Langues', description: 'Allemand et anglais. Niveaux A1 à C1.', cta: 'Voir les Cours' }, digital: { name: 'Solutions Digitales', description: 'Web design, CRM, automatisation IA.', cta: 'Voir le Portfolio' }, relocation: { name: 'Pack Relocation', description: 'Tout pour votre déménagement en Suisse.', cta: 'Pack Complet' }, vehiculos: { name: 'Location de Véhicules', description: 'Location de voitures et utilitaires.', cta: 'Voir Véhicules' }, viviendas: { name: 'Location de Logements', description: 'Appartements et chambres.', cta: 'Voir Logements' }, resultsTitle: 'DES RÉSULTATS QUI', resultsTitleAccent: 'TRANSFORMENT', resultsSubtitle: 'Chaque service résout un problème réel.', viewAll: 'Voir tous les services', explore: 'Explorer', gestoriaShort: 'Gestion', gestoriaDesc: 'Impôts, permis et démarches résolus sans stress.', gestoriaTags: 'Impôts • Permis • RAV', legalShort: 'Conseil Juridique', legalDesc: 'Protégez vos droits.', legalTags: 'Contrats • Héritages • Visas', idiomasShort: 'Langues', idiomasDesc: 'Brisez la barrière de la langue.', idiomasTags: 'Allemand • Anglais • Certificats', segurosShort: 'Assurances', segurosDesc: 'Économisez jusqu\'à 35% sur les primes.', segurosTags: 'Santé • 3e Pilier • Vie', vehiculosShort: 'Location de Voitures', vehiculosDesc: 'Déplacez-vous librement dès le premier jour.', vehiculosTags: 'Berlines • Utilitaires • SUV', viviendasShort: 'Location de Logements', viviendasDesc: 'Trouvez votre logement.', viviendasTags: 'Chambres • Appartements • Colocation', digitalShort: 'Solutions Digitales', digitalDesc: 'Multipliez vos ventes avec site, CRM et IA.', digitalTags: 'Web • CRM • IA', relocationShort: 'Pack Relocation', relocationDesc: 'Arrivez en Suisse sans crainte.', relocationTags: 'Tout inclus', badgeBestSeller: 'Best-seller', badgeNew: 'Nouveau', badgeSave: 'Économisez 25%', act: 'ACTE II', actSubtitle: 'SERVICES' },
  process: { act: 'ACTE III', actSubtitle: 'PROCESSUS', title: 'DE VOTRE PROBLÈME À', titleAccent: 'VOTRE SOLUTION', subtitle: 'Pas de petits caractères. C\'est aussi simple.', step1Title: 'Nous Vous Écoutons', step1Desc: 'Dites-nous ce qui vous préoccupe.', step1Duration: 'Gratuit', step2Title: 'Plan Sans Surprises', step2Desc: 'Vous saurez exactement ce que nous faisons et combien ça coûte.', step2Duration: '24-48h', step3Title: 'Nous Exécutons', step3Desc: 'Vous continuez votre vie. Nous résolvons pour vous.', step3Duration: 'Variable', step4Title: 'Problème Résolu', step4Desc: 'Nous restons avec vous jusqu\'à ce que tout soit résolu.', step4Duration: 'Continu' },
  about: { title: 'À Propos', subtitle: 'Découvrez l\'équipe Punto Hispano', mission: 'Notre mission est de faciliter la vie en Suisse.', heroTitle: 'Qui sommes-nous ?', heroSubtitle: 'Nous sommes le pont entre votre langue et la bureaucratie suisse. Depuis 2013.', stats: { families: 'Familles', procedures: 'Démarches', companies: 'Entreprises', years: 'Années' }, timeline: { t2013: { title: 'Le Premier Pas', desc: 'Santiago arrive en Suisse.' }, t2019: { title: 'Croissance Sans Frontières', desc: 'Des centaines de clients.' }, t2023: { title: 'Notre Maison à Zurich', desc: 'Bureau à Opfikon.' }, t2025: { title: 'Plus de 2 500 Familles', desc: 'Équipe pluridisciplinaire.' } }, valuesTitle: 'Nos Valeurs', values: { transparency: { title: 'Transparence Totale', desc: 'Pas de petits caractères.' }, empathy: { title: 'Empathie Réelle', desc: 'Nous avons été à votre place.' }, results: { title: 'Des Résultats, Pas des Mots', desc: 'Problèmes résolus, pas promesses.' } } },
  contact: { title: 'Contact', subtitle: 'Vous avez des questions ? Nous sommes là pour vous aider', name: 'Nom', email: 'E-mail', phone: 'Téléphone', message: 'Message', send: 'Envoyer le Message', whatsapp: 'Écrivez-nous sur WhatsApp', schedule: 'Prendre Rendez-vous', address: 'Thurgauerstrasse 117, 1er étage, Bureau 181, 8152 Opfikon, Zurich', heroTitle: 'Comment pouvons-nous vous aider ?', heroSubtitle: 'Nous sommes à un message de distance. Première consultation gratuite.', officeTitle: 'Notre Bureau', hours: 'Horaires : Lun-Ven 09h00-18h00', responseTime: 'Réponse en moins de 2 heures', freeConsultation: 'Première consultation 100% gratuite' },
  zones: { title: 'Zones de Service', subtitle: 'Depuis Zurich, pour le monde entier', description: 'Gestion, conseil juridique, assurances et plus.', headquarters: 'Siège Principal', cities: 'villes', countriesTitle: 'Pays avec la Plus Grande Présence', notFound: 'Vous ne trouvez pas votre zone ?', notFoundDesc: 'Nous pouvons vous aider en ligne.', servicesIn: 'Services à', heroTitle: 'Où Que Vous Soyez, Nous Vous Aidons', heroSubtitle: 'Services professionnels depuis Zurich pour toute l\'Europe.', europeTitle: 'Europe', allCountries: 'Voir tous les pays', remoteServices: 'Services 100% en ligne disponibles' },
  blog: { title: 'Blog', subtitle: 'Conseils, guides et actualités', readMore: 'Lire la suite', readTime: 'min de lecture', categories: 'Catégories', search: 'Rechercher des articles...' },
  footer: { description: 'Votre gestion administrative en Suisse', rights: 'Tous droits réservés', privacy: 'Politique de Confidentialité', cookies: 'Politique de Cookies', legal: 'Mentions Légales', gdpr: 'RGPD', brandDesc: 'Votre partenaire intégral en Suisse.', newsletter: 'Newsletter', newsletterDesc: 'Recevez des nouveautés et offres exclusives', subscribe: 'S\'abonner', emailPlaceholder: 'nom@exemple.com', followUs: 'Suivez-nous sur', servicesTitle: 'Services', gestoriaTitle: 'Gestion', lifestyleTitle: 'Lifestyle', zonesTitle: 'Zones', companyTitle: 'Entreprise', legalTitle: 'Légal', zonesLink: 'Zones de Service', madeWith: 'Développé avec ❤️ par', desempleo: 'Chômage (RAV)', administracion: 'Administration', cvDoc: 'CV et Documents', acompanamientos: 'Accompagnements', traducciones: 'Traductions', paquetes: 'Packs Spéciaux' },
  common: { learnMore: 'En savoir plus', viewAll: 'Voir Tous', back: 'Retour', next: 'Suivant', previous: 'Précédent', close: 'Fermer', loading: 'Chargement...', error: 'Une erreur est survenue', retry: 'Réessayer', search: 'Rechercher', noResults: 'Aucun résultat', freeConsultation: 'Consultation Gratuite', whatsapp: 'WhatsApp', schedule: 'Prendre Rendez-vous', callUs: 'Appelez-nous', from: 'Depuis', our: 'Nos', all: 'Tous' },
  audience: { trustLine: 'Plus de 12 ans d\'aide aux francophones en Suisse', empathy: 'Ça vous dit quelque chose ?', empathyItems: ['Vous ne comprenez pas les courriers officiels', 'Vous vous sentez perdu face à la bureaucratie', 'Vous avez besoin d\'aide avec les impôts', 'Vous cherchez quelqu\'un qui parle votre langue'], processTitle: 'C\'est aussi simple', processSteps: [{ title: 'Racontez-nous votre cas', description: 'Par WhatsApp ou rendez-vous' }, { title: 'Nous vous conseillons', description: 'Analyse et options' }, { title: 'Nous résolvons', description: 'Gestion professionnelle pour vous' }] },
  navStructure: { traditional: 'Traditionnels', lifestyle: 'Lifestyle', digital: 'Digitaux', europe: 'Europe', america: 'Amérique', other: 'Autres', viewAllZones: 'Voir toutes les zones', desempleo: 'Chômage et RAV', administracion: 'Administration', cvDoc: 'CV et Documents', traducciones: 'Traductions', paquetes: 'Packs Spéciaux', extranjeria: 'Droit des Étrangers', laboral: 'Droit du Travail', familia: 'Droit de la Famille', mercantil: 'Droit Commercial', inmobiliario: 'Immobilier et Fiscal', aleman: 'Allemand', ingles: 'Anglais', seguroSalud: 'Assurance Maladie', vidaPension: 'Vie et Prévoyance', hogarVehiculos: 'Habitation et Véhicules', siniestros: 'Sinistres', comparador: 'Comparateur', packBasico: 'Pack Basique', packCompleto: 'Pack Complet', paraEmpresas: 'Pour Entreprises', packRetorno: 'Pack Retour', formacionIdiomas: 'Cours de Langues', segurosYPensiones: 'Assurances et Prévoyance', alquilerVehiculos: 'Location de Véhicules', alquilerViviendas: 'Location de Logements', solucionesDigitales: 'Solutions Digitales' },
  testimonials: { act: 'ACTE IV', actSubtitle: 'TÉMOIGNAGES', title: 'ILS VIVENT DÉJÀ', titleAccent: 'SANS SOUCIS', subtitle: 'Histoires réelles de personnes comme vous', reviews: 'avis', viewReal: 'Voir les vrais avis sur Google Maps', disclaimer: 'Les avis affichés ci-dessous sont représentatifs de l\'expérience de nos clients. Pour voir nos avis authentiques et vérifiés, visitez notre profil sur Google Maps.' },
  faq: { act: 'ACTE V', actSubtitle: 'FAQ', title: 'QUESTIONS', titleAccent: 'FRÉQUENTES', subtitle: 'Tout ce que vous devez savoir.', ctaText: 'Vous avez une autre question ?', ctaLink: 'Contactez-nous directement', showMore: 'Voir plus de questions', showLess: 'Voir moins' },
  cta: { act: 'ACTE VI', actSubtitle: 'CONTACT', urgencyBadge: 'Places limitées — Seulement 5 consultations gratuites cette semaine', title: 'N\'ATTENDEZ PAS QU\'IL', titleAccent: 'SOIT TROP TARD', subtitle: 'Chaque jour sans résoudre est du stress inutile. Faites le premier pas — c\'est gratuit.', step1Label: 'Sélectionnez le service', step2Label: 'Données', step3Label: 'Confirmation', stepTitle: 'Quel service vous intéresse ?', continueBtn: 'Continuer à l\'étape 2', trustResponse: 'Réponse en moins de 24h', trustFamilies: '+2500 familles l\'ont résolu', trustLanguage: '100% dans votre langue', serviceOther: 'Autre / Pas sûr' },
  trust: { headline: '+2 500 personnes se sont libérées de la bureaucratie suisse', verifiedLabel: 'Entreprises vérifiées :', dataProtected: 'Données 100% protégées', dataProtectedSub: 'Vos informations sont sacrées', registered: 'Entreprise enregistrée en Suisse', registeredSub: 'Vérifiable sur Moneyhouse', realOffice: 'Bureau réel à Zurich', realOfficeSub: 'Pas une boîte postale', experience: '12+ ans, 2500+ familles', experienceSub: 'Résultats prouvables' },
  homeFaq: { questions: [{ question: 'Je viens d\'arriver en Suisse et je ne sais pas par où commencer. Pouvez-vous m\'aider ?', answer: 'Absolument. Nous savons à quel point c\'est accablant d\'arriver dans un nouveau pays. Notre Pack Relocation couvre tout : permis, assurances, banque, logement et plus. Un coordinateur personnel vous guide pas à pas.' }, { question: 'Combien coûte la première consultation ? Y a-t-il un engagement ?', answer: 'La première consultation est 100% gratuite et sans engagement. En 10 minutes nous écoutons votre cas, comprenons vos besoins et vous expliquons comment nous pouvons vous aider.' }, { question: 'Je paie trop d\'impôts. Pouvez-vous optimiser ma déclaration ?', answer: 'C\'est ce que nous faisons le mieux. En 12+ ans nous avons récupéré des milliers de francs pour nos clients grâce à des déductions méconnues.' }, { question: 'J\'ai un problème juridique et je ne comprends pas les lois suisses. Que faire ?', answer: 'Vous n\'êtes pas seul. Nos conseillers juridiques parlent votre langue et connaissent le droit suisse en détail. Contrats de travail, regroupement familial, héritages, permis — nous protégeons vos droits.' }, { question: 'J\'ai besoin d\'apprendre l\'allemand mais les cours conventionnels ne me conviennent pas.', answer: 'Parce qu\'ils ne sont pas conçus pour les hispanophones. Notre méthodologie part des difficultés spécifiques. Cours de A1 à C1, en présentiel à Zurich ou en ligne.' }, { question: 'Comment savoir si je paie trop pour mon assurance maladie ?', answer: 'Probablement oui — 70% de nos clients économisent en moyenne 35% après notre comparaison gratuite. Nous analysons vos primes, franchises et couvertures.' }, { question: 'Vous ne servez qu\'à Zurich ou aussi à distance ?', answer: 'Notre bureau est à Opfikon (Zurich), mais nous servons des clients de toute la Suisse et de l\'étranger. 80% de nos services sont 100% en ligne.' }, { question: 'Pourquoi devrais-je faire confiance à Punto Hispano plutôt qu\'à un autre ?', answer: 'Parce que nous sommes une entreprise enregistrée et vérifiable sur Moneyhouse. Plus de 2 500 familles nous ont choisis. 4,9 étoiles sur Google.' }], additionalQuestions: [{ question: 'Où êtes-vous exactement ? Puis-je venir au bureau ?', answer: 'Oui, nous sommes au Thurgauerstrasse 117, 8152 Opfikon, Zurich (1er étage, Bureau 181). Lundi à vendredi 9:00-18:00, samedi sur rendez-vous.' }, { question: 'Je veux assurer ma retraite. Quelles options ai-je avec le 3e Pilier ?', answer: 'Le 3e Pilier est le meilleur outil pour sécuriser votre avenir ET économiser sur les impôts. Nous comparons toutes les options du marché.' }, { question: 'Mon entreprise a besoin d\'une présence digitale. Pouvez-vous aider ?', answer: 'Nous concevons des sites qui vendent. CRM personnalisé, automatisation IA, marketing digital et SEO.' }, { question: 'J\'ai besoin d\'une voiture sans complications de longs contrats.', answer: 'Location flexible : de quelques jours à plusieurs mois. Utilitaires, SUV et camionnettes. Assurance tous risques incluse.' }, { question: 'Trouver un appartement en Suisse est impossible. Pouvez-vous vraiment m\'aider ?', answer: 'Nous avons accès à un réseau exclusif de propriétaires, gérons les visites et vous accompagnons jusqu\'à la signature.' }, { question: 'Que comprend exactement le Pack Relocation ?', answer: 'TOUT : recherche de logement, ouverture de compte bancaire, inscription municipale, assurances obligatoires, CV adapté, cours d\'allemand et un coordinateur personnel. Économisez 25%.' }, { question: 'Comment payer ? Acceptez-vous les paiements échelonnés ?', answer: 'Virement, carte, TWINT ou PayPal. Oui, nous proposons des facilités de paiement pour les services importants.' }, { question: 'Je n\'ai pas encore de permis de séjour. Pouvez-vous m\'aider quand même ?', answer: 'Oui. Nous aidons à régulariser les situations migratoires et conseillons sur les meilleures voies pour obtenir votre permis.' }] },
  seo: { homeTitle: 'Punto Hispano | Gestion Administrative en Suisse', homeDescription: 'Meilleure gestion et conseil à Zurich. Fiscalité, juridique, assurances et solutions digitales.' },
  servicesIndex: { heroTitle: 'Tous Nos Services', heroSubtitle: 'Votre solution intégrale en Suisse.', heroCta: 'Consultation Gratuite par WhatsApp', categories: { gestoria: { title: 'Gestion Administrative', description: 'Impôts, RAV, permis — nous nous occupons de tout.', cta: 'Arrêter de m\'inquiéter', features: ['Déclaration sans erreurs', 'Permis à jour', 'Sans stress', 'Économie fiscale réelle'] }, legal: { title: 'Conseil Juridique', description: 'Un contrat incompris peut coûter des milliers de francs.', cta: 'Protéger mes droits', features: ['Contrats vérifiés', 'Permis résolus', 'Regroupement familial', 'Tranquillité juridique'] }, idiomas: { title: 'Cours de Langues', description: 'Sans langue, pas de travail. Nos cours sont pour parler.', cta: 'Commencer à parler', features: ['Professeurs natifs', 'Niveaux A1-C1', 'Petits groupes', 'Certificats officiels'] }, seguros: { title: 'Assurances et Prévoyance', description: 'Chaque année vous perdez des centaines de francs.', cta: 'Comparer et économiser', features: ['Jusqu\'à 35% d\'économie', 'Conseiller personnel', 'Toutes les compagnies', 'Sans engagement'] }, digital: { title: 'Solutions Digitales', description: 'Votre concurrence a déjà un site et CRM. Et vous ?', cta: 'Voir ce qu\'on peut faire', features: ['Site professionnel', 'CRM personnalisé', 'IA & automatisation', 'Marketing digital'] }, vehiculos: { title: 'Location de Véhicules', description: 'Déplacez-vous librement. Voitures, utilitaires et SUV.', cta: 'Voir véhicules', features: ['Pas de caution excessive', 'Assurance incluse', 'Retrait flexible', 'Prix compétitifs'] }, viviendas: { title: 'Location de Logements', description: 'Trouvez votre logement sans concourir avec 200 candidats.', cta: 'Chercher un logement', features: ['Vérifiés', 'Sans commission cachée', 'Court et long terme', 'Zones centrales'] }, relocation: { title: 'Pack Relocation', description: 'Arrivez en Suisse avec tout résolu.', cta: 'Arriver serein', features: ['Tout inclus', 'Conseiller personnel', 'Avant d\'arriver', 'Garantie de résultat'] } } },
  aboutPage: { seoTitle: 'À Propos de Punto Hispano — Gestion Administrative en Suisse', seoDesc: 'Découvrez Punto Hispano: 12+ ans d\'aide en Suisse.', heroSub: 'À Propos de Punto Hispano — Gestion Administrative en Suisse', heroTitle1: 'Le Cabinet de Confiance', heroTitle2: 'pour les ', heroTitle3: 'Hispanophones', heroTitle4: 'en Suisse', heroDesc: 'Nous sommes arrivés en Suisse comme vous. Nous savons ce que c\'est de ne pas comprendre un courrier des impôts. C\'est pourquoi nous avons créé Punto Hispano.', knowServices: 'Découvrir Nos Services →', talkToUs: 'Parlez-nous', originTitle: 'Nous n\'avons pas créé une entreprise. Nous avons résolu un problème que nous avons vécu.', originP1: 'En 2013, Santiago Castillo a fait face à la même chose que vous: un nouveau pays, une langue qu\'il ne maîtrisait pas. Il a cherché de l\'aide en espagnol et n\'en a pas trouvé. Alors il l\'a créée.', originP2: 'Aujourd\'hui, Punto Hispano est l\'endroit où plus de 2.500 familles ont trouvé quelqu\'un qui parle leur langue et défend leurs droits.', originP3: 'Nous ne sommes pas une entreprise qui vend des services. Nous sommes des personnes qui ont résolu le même problème.', originBadge: '🇨🇭 Depuis Zurich, pour toute la communauté en Suisse', timelineTitle: '12 Ans de Croissance avec Vous', founderTag: 'Fondateur', founderName: 'Santiago Castillo', founderQuote: '"Je suis arrivé en Suisse avec une valise et zéro contact. Personne ne m\'a expliqué les impôts, les assurances ni les permis. L\'aide en espagnol n\'existait pas. Alors je l\'ai créée."', founderDesc: 'Aujourd\'hui, plus de 12 ans plus tard, Punto Hispano est la référence de la communauté hispanophone.', founderExp: 'Plus de 12 ans d\'expérience', teamTitle: 'Une Équipe Complète à Votre Service', teamSubtitle: 'Tout sous un même toit.', teamStats: [{ number: '8+', text: 'Professionnels en poste', sub: 'Gestionnaires, avocats, conseillers en assurances, professeurs' }, { number: '100%', text: 'Équipe hispanophone', sub: 'Nous nous comprenons sans traducteur.' }, { number: '5+', text: 'Domaines d\'expertise', sub: 'Gestion, juridique, assurances, langues, digital' }], missionTitle: 'Notre Mission', missionWhat: 'Ce que Nous Faisons Chaque Jour', missionWhatDesc: 'Résoudre les vrais problèmes. Pas de services génériques: nous écoutons, comprenons et résolvons professionnellement.', missionWhere: 'Où Nous Allons', missionWhereDesc: 'Que personne ne se sente seul face à un problème. Nous voulons être votre premier appel.', allServices: 'Tout ce que Punto Hispano Peut Faire pour Vous', allServicesSub: 'Plus de 20 solutions spécifiques.', commitmentsTitle: 'Trois Engagements que Nous Respectons Toujours', commitments: [{ title: 'Réponse en Moins de 2 Heures', desc: 'Pendant les heures de bureau, nous répondons en 2 heures max.', proof: 'Engagement vérifiable' }, { title: 'Première Consultation Gratuite', desc: 'Nous écoutons et vous donnons un diagnostic clair. Sans engagement.', proof: '100% gratuite' }, { title: '4.9★ sur Google', desc: 'Plus de 2.500 familles nous ont choisis et nous recommandent.', proof: 'Avis réels de clients' }], joinTitle: 'Vous Voulez Rejoindre l\'Équipe?', joinDesc: 'Nous cherchons des professionnels passionnés.', joinCta: '✉️ Envoyez-nous votre CV →', finalTitle: 'Vous Avez un Problème en Suisse? Dites-le Nous.', finalDesc: 'Vous n\'avez pas à tout résoudre seul(e). Faites le premier pas.', finalCta: 'Réserver une Consultation Gratuite →', finalServices: 'Voir Tous les Services →' },
  zonesPage: { seoTitle: 'Zones de Service | Punto Hispano - Depuis Zurich pour le Monde Entier', seoDesc: 'Gestion administrative, conseil juridique, assurances et plus.', heroTitle: 'Nous Servons Votre Zone', heroSubtitle: 'Depuis Zurich, pour le monde entier. Gestion, conseil juridique, assurances et plus.', hq: 'Siège Principal', switzerland: 'Suisse', switzerlandDesc: 'Avec notre bureau à Opfikon (Zurich), nous servons toute la communauté en Suisse.', countriesTitle: 'Pays avec Plus Grande Présence', countriesSubtitle: 'Trouvez nos services en Suisse, Espagne, Italie et Amérique Latine.', cities: 'villes', notFoundTitle: 'Vous ne trouvez pas votre zone?', notFoundDesc: 'Où que vous soyez, nous pouvons vous aider en ligne.', whatsappCta: 'Contacter par WhatsApp', scheduleCta: 'Prendre Rendez-vous' },
  blogPage: { seoTitle: 'Blog Punto Hispano | Guides pour la Vie en Suisse', seoDesc: 'Guides sur les impôts, permis, assurances et vie en Suisse.', heroTitle: 'Blog de Punto Hispano — ', heroTitleAccent: 'Guides et Conseils pour la Vie en Suisse', heroDesc: 'Tout ce que vous devez savoir pour vivre, travailler et prospérer en Suisse.', all: 'Tous', readArticle: 'Lire l\'article', readTime: 'min de lecture', noArticles: 'Aucun article disponible dans cette catégorie.', newsletterTitle: '📬 Recevez Nos Articles par Email', newsletterDesc: 'Un email par semaine. Pas de spam, que du contenu utile.', emailPlaceholder: 'Votre email...', subscribe: 'S\'abonner', noSpam: '🔒 Sans spam. Annulable à tout moment.' },
  blogPost: { home: 'Accueil', blog: 'Blog', author: 'Équipe Punto Hispano', minRead: 'min de lecture', needHelpMobileTitle: 'Besoin d\'aide avec ça ?', needHelpMobileDesc: 'Première consultation gratuite. Notre équipe peut s\'en charger pour vous.', scheduleConsult: 'Prendre rendez-vous →', endCtaTitle: 'Vous voulez qu\'on s\'en occupe pour vous ?', endCtaDesc: 'Vous n\'avez pas à le faire seul(e). Réservez votre consultation gratuite et nous vous expliquerons exactement comment nous pouvons vous aider.', endCtaButton: 'Réserver Consultation Gratuite →', endCtaResponse: '⏰ Réponse en moins de 2 heures aux heures de bureau', keepReading: 'Continuer à lire', backToBlog: 'Retour au Blog', sidebarHelpTitle: 'Besoin d\'aide ?', sidebarHelpDesc: 'Première consultation gratuite. Notre équipe peut s\'en charger pour vous.', relatedArticles: 'Articles connexes', mobileStickyCta: 'Consultation gratuite' },
  zonesDetail: {
    seoTitleCountry: 'Services en {country} | Punto Hispano - Assistance depuis Zurich',
    seoDescCountry: 'Gestion, conseil juridique, assurances et langues en {country}. Assistance en présentiel et en ligne depuis Opfikon, Zurich.',
    seoTitleCity: 'Services à {city}, {country} | Punto Hispano',
    seoDescCity: 'Gestion, conseil juridique, assurances et plus à {city}. Assistance en présentiel et en ligne depuis Opfikon, Zurich.',
    citiesIn: 'Villes en {country}',
    findYourCity: 'Trouvez votre ville et découvrez tous les services disponibles.',
    cities: 'villes',
    featured: '★ En vedette',
    noZones: 'Aucune zone disponible dans ce pays actuellement.',
    contactAnyway: 'Contacter quand même',
    dontSeeCity: 'Vous ne voyez pas votre ville ?',
    dontSeeCityDesc: 'Peu importe où vous êtes en {country}, nous vous assistons en ligne depuis Zurich.',
    contactWhatsApp: 'Contacter par WhatsApp',
    allZones: 'Toutes les zones',
    servicesForIn: 'Services pour les Francophones à {city}',
    servicesFullDesc: 'Chez Punto Hispano, nous offrons une gamme complète de services à {city}. De la gestion administrative au conseil juridique, assurances, cours de langues et solutions digitales. Notre bureau principal est à Opfikon (Zurich), mais nous vous assistons en ligne où que vous soyez.',
    needHelpIn: 'Besoin d\'aide à {city} ?',
    remoteAttention: 'Même si vous êtes à {city}, nous vous assistons comme si vous étiez dans notre bureau de Zurich. Contactez-nous aujourd\'hui.',
    officeOpfikon: 'Bureau à Opfikon, Suisse',
    inPersonAndOnline: 'Assistance en présentiel et en ligne',
    scheduleConsultation: 'Prendre Rendez-vous',
    otherCitiesIn: 'Autres villes en {country}',
    exploreMore: 'Explorez d\'autres zones où nous offrons nos services.',
    viewAllCitiesIn: 'Voir toutes les villes en {country}',
    backTo: 'Retour à {country}',
    allServices: 'Tous Nos Services',
    servicesIn: 'Services à {zone}',
    availableFromOffice: 'Disponibles en présentiel et en ligne depuis notre bureau à Opfikon, Zurich.',
    viewMore: 'En savoir plus',
    mainOffice: 'Bureau Principal',
    onlineConsultation: 'Consultation en Ligne',
    serviceGestoria: 'Gestion',
    serviceGestoriaDesc: 'Impôts, permis, RAV',
    serviceLegal: 'Conseil Juridique',
    serviceLegalDesc: 'Contrats, visas, héritages',
    serviceLanguages: 'Langues',
    serviceLanguagesDesc: 'Allemand, anglais, certificats',
    serviceInsurance: 'Assurances',
    serviceInsuranceDesc: 'Santé, vie, 3e pilier',
    serviceCarRental: 'Location de Voitures',
    serviceCarRentalDesc: 'Berlines, utilitaires',
    serviceHousing: 'Logements',
    serviceHousingDesc: 'Chambres, appartements, colocation',
    serviceDigital: 'Digital',
    serviceDigitalDesc: 'Web, CRM, IA, automatisation',
    serviceRelocation: 'Pack Relocation',
    serviceRelocationDesc: 'Tout inclus pour arriver',
    howWeHelp: 'Comment Nous Vous Aidons',
    remotely: 'à Distance',
    remoteDesc: 'Même si vous êtes à {city}, nous vous assistons comme dans notre bureau de Zurich.',
    remoteDescGeneral: 'Depuis Zurich, pour le monde entier. Assistance professionnelle quel que soit votre emplacement.',
    step1Title: 'Contactez-Nous',
    step1Desc: 'Écrivez-nous par WhatsApp, email ou appelez-nous. Réponse en moins de 24h.',
    step2Title: 'Consultation en Ligne',
    step2Desc: 'Nous programmons un appel vidéo pour comprendre votre situation.',
    step3Title: 'Résolution',
    step3Desc: 'Nous gérons tout à distance. Vous signez uniquement les documents nécessaires.',
    benefit1: 'Réponse en 24h',
    benefit2: '+12 ans d\'expérience',
    benefit3: 'Assistance multilingue',
    home: 'Accueil',
    zones: 'Zones',
    gestoriaAndAdvice: 'Gestion et Conseil à {city}',
    professionalServices: 'Services professionnels à {city}',
    servicesDescription: 'Gestion, conseil juridique, assurances et plus en {country}. Assistance depuis notre bureau à Zurich.',
  },
  gestoriaPage: {
    seoTitle: 'Gestion Administrative en Suisse | Impôts, Permis, ORP | Punto Hispano',
    seoDesc: 'Gestion administrative en espagnol en Suisse. Inscription ORP, déclaration d\'impôts, traductions officielles, création d\'entreprise. Plus de 12 ans d\'expérience.',
    heroTitle: 'Gestion Administrative en Suisse',
    heroAccent: '— Impôts, Permis et ORP en Espagnol',
    heroDesc: 'Encore une année sans comprendre votre déclaration d\'impôts ? Des lettres de l\'ORP auxquelles vous ne savez pas répondre ? Nous nous occupons de tout. Vous recevez uniquement le résultat.',
    heroCta: 'Voir tous les services ↓',
    heroWhatsapp: 'Consultation gratuite par WhatsApp',
    badge1: '+2 500 familles',
    badge2: 'Réponse < 2h',
    badge3: '12+ ans',
    empathyTitle: 'Ça vous dit quelque chose ?',
    empathy1: 'La date limite de la déclaration approche et vous ne comprenez pas la première ligne',
    empathy2: 'Vous recevez des lettres de l\'ORP en allemand et ne savez pas ce qu\'on vous demande',
    empathy3: 'Vous devez renouveler votre permis et avez peur d\'un refus',
    empathy4: 'Vous voulez créer une entreprise mais la paperasse suisse vous paralyse',
    empathyBottom: 'Si vous vous reconnaissez, vous êtes au bon endroit.',
    categoriesTitle: 'Que devez-vous résoudre ?',
    categoriesDesc: 'Choisissez votre situation et nous vous montrons exactement comment nous pouvons vous aider.',
    packagesTitle: 'Forfaits tout-en-un',
    packagesDesc: 'Solutions complètes pour des situations concrètes.',
    requestPack: 'Demander le forfait',
    processTitle: 'C\'est aussi simple',
    step1Title: 'Racontez-nous votre cas',
    step1Desc: 'Écrivez-nous sur WhatsApp ou remplissez le formulaire',
    step2Title: 'Recevez votre plan',
    step2Desc: 'Nous vous disons ce dont vous avez besoin et combien ça coûte',
    step3Title: 'Nous nous en occupons',
    step3Desc: 'Vous nous donnez les documents, nous faisons le reste',
    ctaTitle: 'Pas sûr du service dont vous avez besoin ?',
    ctaDesc: 'Racontez-nous votre situation et nous vous dirons exactement ce dont vous avez besoin. Gratuit et sans engagement.',
    ctaWhatsapp: 'Consultation gratuite par WhatsApp',
    ctaSchedule: 'Planifier un appel',
    faqTitle: 'Questions fréquentes',
    faq1Q: 'Combien coûte l\'inscription à l\'ORP ?',
    faq1A: 'Écrivez-nous sur WhatsApp ou remplissez notre formulaire de contact et nous vous enverrons un devis personnalisé en moins de 2 heures. Le Pack Inscription ORP comprend toute la documentation, CV format suisse, lettre de motivation, inscription JOB-room et accompagnement au premier rendez-vous.\n\n⚠️ N\'oubliez pas : vous devez vous inscrire AVANT votre premier jour sans travail.',
    faq2Q: 'Comment faire ma déclaration d\'impôts ?',
    faq2A: 'Vous pouvez la faire vous-même ou engager notre service de déclaration d\'impôts. Nous examinons votre situation complète, appliquons TOUTES les déductions possibles et la déposons dans les délais.\n\n⚠️ Délai : dans la plupart des cantons, la date limite est le 31 mars.',
    faq3Q: 'La première consultation est-elle gratuite ?',
    faq3A: 'Oui. Nous offrons une première consultation gratuite de 10 minutes où nous écoutons votre cas et identifions vos besoins. Vous pouvez venir à notre bureau à Opfikon, nous appeler ou nous écrire sur WhatsApp. Sans engagement.',
    faqMore: 'D\'autres questions ? Contactez-nous →',
    reviewsTitle: 'Ce que disent nos clients',
    reviewsDesc: 'Expériences réelles de familles hispanophones',
    reviewsMore: 'Voir tous les avis sur Google →',
    crossSellTitle: 'Découvrez nos autres services',
    crossSellDesc: 'Tout ce dont un hispanophone a besoin en Suisse, sous un même toit.',
    finalTitle: 'Arrêtez de vous inquiéter. Commencez aujourd\'hui.',
    finalDesc: 'Chaque jour sans résoudre vos démarches est un jour de stress en plus.',
    finalCta: 'Consultation gratuite par WhatsApp',
    finalBack: 'Voir les services ↑',
  },
  homeSeo: {
    title: 'Punto Hispano | Gestion, Juridique et Relocation en Suisse',
    description: 'Perdu avec les démarches en Suisse ? +2500 hispanophones ont retrouvé leur tranquillité. Impôts, permis, assurances, logement et plus.',
    skipButton: 'Voir le site complet',
  },

  legalPage: {
    seoTitle: 'Conseil Juridique pour Hispanophones en Suisse | Punto Hispano',
    seoDesc: 'Conseil juridique en espagnol en Suisse. Immigration, travail, famille, commercial, immobilier. Première consultation gratuite.',
    heroTitle: 'Conseil Juridique pour Hispanophones en Suisse',
    heroAccent: '— Permis, Travail, Famille et Entreprises en Espagnol',
    heroDesc: 'Problèmes avec votre permis, licenciement injuste, divorce, dettes... Vous n\'avez pas à le résoudre seul(e). Nous vous conseillons en espagnol avec des spécialistes du droit suisse.',
    heroCta: 'Voir les Domaines de Pratique ↓',
    heroWhatsapp: 'Consultation Gratuite par WhatsApp',
    badge1: '+2 500 familles',
    badge2: 'Réponse < 2h',
    badge3: '12+ ans',
    empathyTitle: 'L\'une de ces situations vous semble familière ?',
    empathy1: 'Vous avez été licencié(e) et pensez que c\'est injuste mais ne savez pas quoi faire',
    empathy2: 'Vous êtes en procédure de divorce et ne comprenez pas le droit suisse',
    empathy3: 'Votre permis a été refusé et vous ne savez pas comment faire recours',
    empathy4: 'Votre propriétaire a augmenté le loyer et vous ne savez pas si c\'est légal',
    empathyBottom: 'Si vous vous identifiez à l\'une d\'elles, vous êtes au bon endroit.',
    categoriesTitle: 'Nos Domaines de Pratique Juridique',
    categoriesDesc: 'Choisissez votre situation et nous vous montrons comment nous pouvons aider.',
    cat1Name: 'Immigration et Permis',
    cat1Desc: 'Permis B, C, G, renouvellements, regroupement familial, recours en cas de refus, nationalité suisse.',
    cat1Badge: '7 services disponibles',
    cat2Name: 'Droit du Travail',
    cat2Desc: 'Licenciements, contrats, réclamations, mobbing, certificats de travail, heures supplémentaires, faillite.',
    cat2Badge: '8 services disponibles',
    cat3Name: 'Droit de la Famille',
    cat3Desc: 'Divorces, garde, pensions alimentaires, séparation de biens, médiation, regroupement d\'enfants.',
    cat3Badge: '7 services disponibles',
    cat4Name: 'Droit Commercial et des Entreprises',
    cat4Desc: 'Création d\'entreprise, contrats, litiges entre associés, recouvrement, réclamations d\'assurance.',
    cat4Badge: '6 services disponibles',
    cat5Name: 'Immobilier et Fiscal',
    cat5Desc: 'Achat/vente, locations, litiges avec propriétaires, optimisation fiscale, recours fiscaux.',
    cat5Badge: '6 services disponibles',
    viewServices: 'Voir les services →',
    ctaTitle: 'Vous ne savez pas quel domaine juridique vous avez besoin ?',
    ctaDesc: 'Dites-nous votre situation et nous vous orientons gratuitement. Sans engagement.',
    ctaWhatsapp: 'Consultation Gratuite par WhatsApp',
    ctaSchedule: 'Planifier un Appel',
    processTitle: 'C\'est aussi simple que ça',
    step1: 'Racontez-nous votre cas',
    step2: 'Recevez votre plan juridique',
    step3: 'Nous nous en chargeons',
    faqTitle: 'Questions Fréquentes',
    faqMore: 'Voir plus de questions →',
    reviewsTitle: 'Ce que disent nos clients',
    crossSellTitle: 'Découvrez nos autres services',
    crossSellDesc: 'Tout ce dont un hispanophone a besoin en Suisse, sous un même toit.',
    finalTitle: 'Besoin de conseil juridique ?',
    finalDesc: 'Première consultation gratuite avec nos spécialistes du droit suisse.',
    finalCta: 'Demander une consultation gratuite',
  },

  idiomasPage: {
    seoTitle: 'Formation en Langues pour Hispanophones en Suisse | Punto Hispano',
    seoDesc: 'Cours d\'allemand et d\'anglais conçus pour les hispanophones. Cours en présentiel et en ligne à Zurich.',
    heroTitle: 'Formation en Langues pour Hispanophones en Suisse',
    heroAccent: '— Allemand, Anglais et Certifications Officielles',
    heroDesc: 'Des meilleures écoles de Zurich avec une méthodologie conçue pour les hispanophones. Apprenez plus vite, avec moins de frustration, et certifiez-vous avec garantie.',
    heroCta: 'Voir les Cours ↓',
    badge1: '+450 étudiants',
    empathyTitle: 'L\'une de ces situations vous semble familière ?',
    empathy1: 'Vous ne comprenez rien au bureau et tout est en allemand',
    empathy2: 'Vous avez besoin du B1 pour le permis C et ne savez pas par où commencer',
    empathy3: 'Votre chef exige de l\'anglais professionnel et vous bloquez en réunion',
    empathy4: 'Vous voulez vous certifier mais les examens officiels vous font peur',
    empathyBottom: 'Si vous vous identifiez à l\'une d\'elles, vous êtes au bon endroit.',
    coursesTitle: 'Que voulez-vous apprendre ?',
    coursesDesc: 'Choisissez votre objectif et nous vous montrons le chemin le plus rapide.',
    germanTitle: 'Cours d\'Allemand',
    germanDesc: 'En présentiel et en ligne. Cours en groupe et privés. De A1 à C1, avec méthodologie adaptée aux hispanophones.',
    germanBadge: 'Présentiel · En ligne · Privé',
    germanCta: 'Voir les cours d\'allemand →',
    englishTitle: 'Cours d\'Anglais',
    englishDesc: 'En présentiel et en ligne. Cours en groupe et privés. Business English, conversation et préparation aux certifications.',
    englishBadge: 'Présentiel · En ligne · Privé',
    englishCta: 'Voir les cours d\'anglais →',
    processTitle: 'C\'est aussi simple que ça',
    step1Title: 'Faites votre test de niveau',
    step1Desc: 'Nous évaluons votre niveau actuel lors d\'un appel ou avec notre formulaire',
    step2Title: 'Choisissez votre cours',
    step2Desc: 'Nous vous recommandons le programme idéal pour vos objectifs',
    step3Title: 'Commencez à parler',
    step3Desc: 'Dès le premier cours, vous pratiquez la conversation réelle',
    ctaTitle: 'Vous ne savez pas quel cours choisir ?',
    ctaDesc: 'Faites votre test de niveau gratuit et nous vous recommandons le programme parfait.',
    ctaWhatsapp: 'Contactez-nous par WhatsApp',
    faqTitle: 'Questions Fréquentes',
    faqMore: 'Plus de questions ? Écrivez-nous →',
    reviewsTitle: 'Ce que disent nos étudiants',
    reviewsDesc: 'Expériences réelles d\'hispanophones qui ont appris avec nous',
    reviewsMore: 'Voir tous les avis sur Google →',
    crossSellTitle: 'Découvrez nos autres services',
    crossSellDesc: 'Tout ce dont un hispanophone a besoin en Suisse, sous un même toit.',
    finalTitle: 'Prêt(e) à maîtriser la langue ?',
    finalDesc: 'Chaque semaine sans apprendre est une opportunité manquée.',
    finalCta: 'Cours d\'essai gratuit',
  },

  segurosPage: {
    seoTitle: 'Assurance Maladie en Espagnol en Suisse | LAMal | Troisième Pilier | Punto Hispano',
    seoDesc: 'Conseil en assurances en espagnol en Suisse. Assurance maladie obligatoire LAMal, troisième pilier, retraites. Conseil gratuit. Économisez jusqu\'à 30%.',
    heroTitle: 'Assurances et Retraites pour Hispanophones en Suisse',
    heroAccent: '— LAMal, Troisième Pilier et Économies en Espagnol',
    heroDesc: '70% des hispanophones en Suisse paient plus que nécessaire pour leur assurance maladie. Nous analysons votre police, trouvons les économies et gérons le changement complet.',
    heroCta: 'Voir tous les services ↓',
    heroWhatsapp: 'Consultation gratuite par WhatsApp',
    breadServices: 'Services',
    breadSeguros: 'Assurances et Retraites',
    badge1: 'CICERO N° 31700',
    badge2: 'FINMA N° F014686595',
    badge3: '+20 000 personnes assurées en 5 ans',
    empathyTitle: 'L\'une de ces situations vous semble familière ?',
    empathy1: 'Vous n\'avez pas révisé votre troisième pilier depuis des années et ne savez pas si vous perdez de l\'argent',
    empathy2: 'Votre famille s\'est agrandie mais votre assurance est restée la même',
    empathy3: 'Vous recevez des lettres de votre assureur en allemand et ne comprenez pas ce qu\'on vous demande',
    empathy4: 'Vous payez plus de 400 CHF/mois d\'assurance maladie et ne savez pas si c\'est nécessaire',
    empathyBottom: 'Si vous vous identifiez à l\'une d\'elles, vous êtes au bon endroit.',
    servicesTitle: 'Que devez-vous protéger ?',
    servicesDesc: 'Choisissez votre situation et nous vous montrons comment économiser sans perdre de couverture.',
    processTitle: 'C\'est aussi simple que ça',
    step1Title: 'Racontez-nous votre situation',
    step1Desc: 'Dites-nous quelles assurances vous avez et combien vous payez',
    step2Title: 'Nous comparons pour vous',
    step2Desc: 'Nous analysons toutes les options du marché suisse',
    step3Title: 'Vous économisez sans effort',
    step3Desc: 'Nous gérons le changement complet. Vous signez simplement',
    ctaTitle: 'Payez-vous trop cher pour votre assurance ?',
    ctaDesc: 'Envoyez-nous votre police actuelle et en 24h nous vous dirons combien vous pouvez économiser. Gratuit et sans engagement.',
    ctaWhatsapp: 'Consultation gratuite par WhatsApp',
    ctaSchedule: 'Planifier un appel',
    faqTitle: 'Questions Fréquentes',
    faqMore: 'Plus de questions ? Écrivez-nous →',
    reviewsTitle: 'Ce que disent nos clients',
    reviewsDesc: 'Expériences réelles de familles qui ont économisé avec nous',
    reviewsMore: 'Voir tous les avis sur Google →',
    crossSellTitle: 'Découvrez nos autres services',
    crossSellDesc: 'Tout ce dont un hispanophone a besoin en Suisse, sous un même toit.',
    finalTitle: 'Arrêtez de trop payer. Commencez à économiser aujourd\'hui.',
    finalDesc: 'Chaque mois sans réviser votre assurance est de l\'argent perdu.',
    finalCta: 'Consultation gratuite par WhatsApp',
    finalBack: 'Voir les services ↑',
  },

  digitalPage: {
    seoTitle: 'Solutions Digitales Avancées - Développement Web, CRM, IA & Marketing | Punto Hispano',
    seoDesc: 'Transformation digitale complète pour les entreprises en Suisse : développement web professionnel, CRM intelligent, chatbots IA, automatisation et marketing digital.',
    seoKeywords: 'solutions digitales suisse, développement web professionnel, CRM entreprise, intelligence artificielle, chatbots, automatisation, marketing digital, SEO suisse',
    reviewsTitle: 'CE QUE DISENT NOS',
    reviewsAccent: 'CLIENTS',
    reviewsDesc: 'Expériences réelles d\'entreprises qui font confiance à Punto Hispano',
  },

  emprendeDigitalPage: {
    seoTitle: 'Solutions Digitales pour Entreprises | Web, CRM, IA | Punto Hispano',
    seoDesc: 'Catalogue complet de services digitaux : développement web, CRM, chatbots IA, automatisation, marketing digital.',
    backLink: 'Retour à Emprende',
    badge: 'Catalogue de Services',
    title: 'Solutions Digitales',
    subtitle: 'Services technologiques complets pour développer votre entreprise dans le monde digital. Du développement web à l\'intelligence artificielle.',
    webTitle: 'Développement Web',
    webDesc: 'Sites web modernes, rapides et optimisés pour convertir les visiteurs en clients.',
    ecommerceTitle: 'E-commerce / Boutique en Ligne',
    ecommerceDesc: 'Boutiques en ligne complètes avec gestion des produits, paiements et livraisons.',
    appTitle: 'Applications Mobiles',
    appDesc: 'Apps natives ou hybrides pour iOS et Android avec une expérience premium.',
    chatbotTitle: 'Chatbots IA',
    chatbotDesc: 'Automatisez le service client 24/7 avec l\'intelligence artificielle.',
    automationTitle: 'Automatisation des Processus',
    automationDesc: 'Optimisez vos flux de travail et gagnez du temps sur les tâches répétitives.',
    marketingTitle: 'Marketing Digital',
    marketingDesc: 'Stratégies marketing qui génèrent des résultats mesurables.',
    whatIncludes: 'Qu\'est-ce qui est inclus ?',
    additionalTitle: 'Services Supplémentaires',
    additionalDesc: 'Complétez votre projet avec ces services spécialisés.',
    customDev: 'Développement sur mesure',
    customDevDesc: 'Logiciel personnalisé pour vos besoins',
    graphicDesign: 'Design Graphique',
    graphicDesignDesc: 'Logos, branding et matériaux corporatifs',
    seoAudit: 'Audit SEO',
    seoAuditDesc: 'Analyse complète de votre présence en ligne',
    emailMarketing: 'Email Marketing',
    emailMarketingDesc: 'Campagnes email automatisées',
    socialMedia: 'Réseaux Sociaux',
    socialMediaDesc: 'Gestion et contenu pour les réseaux sociaux',
    techConsulting: 'Conseil Tech',
    techConsultingDesc: 'Conseil en technologie et transformation digitale',
    ctaTitle: 'Besoin de quelque chose de différent ?',
    ctaDesc: 'Si vous ne trouvez pas exactement ce que vous cherchez, parlez-nous de votre idée et nous créerons une solution personnalisée.',
    ctaSend: 'Soumettre Mon Projet',
    ctaConsult: 'Consultation Gratuite',
  },

  viviendasPage: {
    seoTitle: 'Location de Chambres en Suisse | Punto Hispano',
    seoDesc: 'Chambres meublées en Suisse avec WiFi, chauffage et services inclus. Contrats flexibles. Assistance en espagnol.',
    badgeLoading: 'Chargement...',
    badgeAvailable: 'logements disponibles',
    badgeComingSoon: 'Nouveaux logements bientôt',
    heroTitle: 'Trouvez votre logement en Suisse',
    heroDesc: 'Chambres et appartements meublés pour hispanophones. Tout inclus, contrats flexibles, assistance en espagnol.',
    where: 'Où ?',
    allCities: 'Toutes les villes',
    checkIn: 'Arrivée',
    checkOut: 'Départ',
    guests: 'Voyageurs',
    guestsAny: 'Peu importe',
    guestsPerson: 'personne',
    guestsPersons: 'personnes',
    guestsPlus: '4+ personnes',
    search: 'Rechercher',
    insurance: 'Assurance complète',
    noDeposit: 'Sans caution',
    freeCancellation: 'Annulation gratuite',
    wifiIncluded: 'WiFi inclus',
    wifiDesc: 'Internet haut débit',
    waterIncluded: 'Eau incluse',
    waterDesc: 'Sans frais supplémentaires',
    heating: 'Chauffage',
    heatingDesc: 'Climatisation complète',
    spanishSupport: 'Assistance espagnol',
    spanishSupportDesc: 'Attention personnalisée',
    filterAll: 'Tous',
    filterRoom: 'Chambre',
    filterDouble: 'Double',
    filterStudio: 'Studio',
    filterApartment: 'Appartement complet',
    sortRecommended: 'Recommandés',
    sortPriceAsc: 'Prix : croissant',
    sortPriceDesc: 'Prix : décroissant',
    sortNewest: 'Plus récents',
    searching: 'Recherche...',
    showing: 'Affichage de',
    accommodations: 'logements',
    noAccommodations: 'Aucun logement disponible actuellement',
    sortBy: 'Trier par :',
    whyChooseUs: 'Pourquoi nous choisir ?',
    bestOption: 'La meilleure option pour les hispanophones en Suisse',
  },

  vehiculosPage: {
    seoTitle: 'Location de Véhicules en Suisse | Comparateur de Prix | Punto Hispano',
    seoDesc: 'Comparez et réservez des voitures de location en Suisse. Assurance complète, kilométrage illimité et assistance en espagnol.',
    badgeText: 'Comparateur de Location',
    heroTitle: 'Trouvez votre véhicule idéal',
    heroDesc: 'Comparez les prix et réservez en ligne. Assurance incluse, kilométrage illimité et assistance en espagnol.',
    trustInsurance: 'Assurance complète sans franchise',
    trustKm: 'Kilométrage illimité inclus',
    trustGps: 'GPS et assistance 24/7',
    trustSpanish: 'Assistance 100% en espagnol',
    loading: 'Chargement...',
    loadingFleet: 'Chargement de la flotte disponible...',
    errorTitle: 'Erreur lors du chargement des véhicules',
    errorDesc: 'Veuillez réessayer plus tard',
    showing: 'Affichage de',
    vehiclesAvailable: 'véhicules disponibles',
    noVehiclesTitle: 'Aucun véhicule pour ces dates',
    noVehiclesDesc: 'Essayez de modifier les dates ou sélectionnez un autre lieu de prise en charge.',
    changeDates: 'Changer les dates',
    clearFilters: 'Effacer les filtres',
    needHelp: 'Besoin d\'aide personnalisée ?',
    contactWhatsapp: 'Contacter par WhatsApp',
    filters: 'Filtres',
    ctaTitle: 'Prêt à louer votre voiture ?',
    ctaDesc: 'Réservez maintenant avec kilométrage illimité, GPS inclus et assurance complète.',
    ctaWhatsapp: 'Réserver par WhatsApp',
    ctaContact: 'Formulaire de Contact',
  },

  relocationPage: {
    seoTitle: 'Pack Relocation Suisse | Émigrer Sans Risques | Punto Hispano',
    seoDesc: 'Service complet de relocation en Suisse. Logement vérifié, formalités complètes, accompagnement en personne. Dès 349 CHF.',
    seoKeywords: 'relocation suisse, émigrer suisse, déménagement suisse, pack relocation, punto hispano',
    breadHome: 'Accueil',
    breadServices: 'Services',
    breadRelocation: 'Pack Relocation',
    badge1: '100% Réussite',
    badge2: '+50 Familles',
    badge3: '+10 Ans',
    heroTitle: 'Émigrer en Suisse',
    heroAccent: 'Sans Risques',
    heroDesc: 'Le seul cabinet qui vous garantit un logement vérifié, une documentation complète et un accompagnement avant votre arrivée jusqu\'à votre intégration totale.',
    heroCta: 'Voir les Packs',
    heroWhatsapp: 'Consultation Gratuite',
    empathyTitle: 'Ça vous dit quelque chose ?',
    empathyDesc: 'Émigrer est excitant, mais ça peut aussi être accablant',
    empathy1Title: 'Arriver sans savoir par où commencer',
    empathy1Desc: 'Vous ne parlez pas la langue, ne connaissez pas le système et chaque démarche ressemble à un labyrinthe.',
    empathy2Title: 'Peur des arnaques immobilières',
    empathy2Desc: 'Agences fantômes, cautions perdues et contrats abusifs sont plus courants qu\'on ne pense.',
    empathy3Title: 'Des papiers que vous ne comprenez pas',
    empathy3Desc: 'Permis B, assurance obligatoire, inscription communale... tout en allemand, français ou italien.',
    empathy4Title: 'Se sentir seul en arrivant',
    empathy4Desc: 'Sans réseau de soutien, sans savoir à qui demander ni où aller quand quelque chose va mal.',
    empathyBottom: 'Si quelque chose vous semble familier, vous n\'êtes pas seul.',
    empathyBottomBold: 'Plus de 50 familles',
    empathyBottomEnd: 'ont déjà émigré avec nous sans passer par tout ça.',
    packsTitle: 'Paquets de Relocation',
    packsDesc: 'Choisissez le paquet parfait pour votre déménagement en Suisse',
    packMostSold: '⭐ Plus Vendu',
    processTitle: 'C\'est aussi simple',
    step1Title: 'Racontez-nous votre situation',
    step1Desc: 'Nous faisons une évaluation gratuite pour comprendre vos besoins.',
    step2Title: 'Nous préparons tout',
    step2Desc: 'Documentation, logement vérifié, assurances et démarches : tout prêt avant votre arrivée.',
    step3Title: 'Vous arrivez et profitez',
    step3Desc: 'Nous vous accompagnons en personne le premier jour et offrons un support étendu.',
    faqTitle: 'Questions Fréquentes',
    crossSellTitle: 'Services Complémentaires',
    finalTitle: 'Prêt à franchir le pas ?',
    finalDesc: 'Plus de 50 familles ont déjà émigré avec notre aide.',
    finalCta: 'Commencer votre Relocation',
  },

  emprendePage: {
    seoTitle: 'Lancez votre business digital | Développement Web & Solutions Digitales | Punto Hispano',
    seoDesc: 'Boostez votre activité digitale : développement web, CRM, IA, automatisation et marketing.',
    badge: 'Solutions Digitales',
    heroTitle1: 'Boostez Votre',
    heroTitle2: ' Business Digital',
    heroDesc: 'Développement web, intelligence artificielle, automatisation et marketing digital. Nous transformons vos idées en solutions technologiques.',
    ctaIdea: 'Partagez Votre Idée',
    ctaSolutions: 'Voir les Solutions',
    servicesTitle: 'Nos Services Digitaux',
    servicesDesc: 'Solutions technologiques complètes pour développer votre activité.',
    svc1Title: 'Développement Web', svc1Desc: 'Sites web modernes et rapides optimisés pour la conversion.', svc1F1: 'Design responsive', svc1F2: 'SEO inclus', svc1F3: 'CMS intégré',
    svc2Title: 'Chatbots IA', svc2Desc: 'Automatisez le service client 24/7 avec l\'IA.', svc2F1: 'Réponses naturelles', svc2F2: 'Multilingue', svc2F3: 'Intégration CRM',
    svc3Title: 'Automatisation', svc3Desc: 'Optimisez vos processus métier.', svc3F1: 'Workflows', svc3F2: 'Intégrations', svc3F3: 'Rapports automatiques',
    svc4Title: 'Apps Mobiles', svc4Desc: 'Applications natives ou hybrides pour iOS et Android.', svc4F1: 'UI/UX premium', svc4F2: 'Notifications push', svc4F3: 'Mode hors ligne',
    svc5Title: 'Marketing Digital', svc5Desc: 'Stratégies marketing aux résultats mesurables.', svc5F1: 'SEO & SEM', svc5F2: 'Réseaux Sociaux', svc5F3: 'Email Marketing',
    svc6Title: 'E-commerce', svc6Desc: 'Boutiques en ligne complètes avec paiements et gestion de stock.', svc6F1: 'Paiements sécurisés', svc6F2: 'Gestion des stocks', svc6F3: 'Expédition automatisée',
    processTitle: 'Comment Nous Travaillons',
    processDesc: 'Un processus clair et transparent de votre idée au produit final.',
    proc1: 'Partagez votre idée', proc1Desc: 'Décrivez votre projet et vos objectifs.',
    proc2: 'Analyse et proposition', proc2Desc: 'Nous évaluons la faisabilité technique et présentons une proposition détaillée.',
    proc3: 'Développement', proc3Desc: 'Nous construisons votre solution avec des méthodes agiles.',
    proc4: 'Lancement', proc4Desc: 'Nous déployons votre projet et vous accompagnons au lancement.',
    card1Title: 'Transmettez Votre Idée', card1Desc: 'Vous avez un projet en tête ? Parlez-nous en.', card1Cta: 'Envoyer l\'idée',
    card2Title: 'Gagnez de l\'Argent en Ligne', card2Desc: 'Apprenez à monétiser vos compétences.', card2Cta: 'Voir les Guides',
    card3Title: 'Collaborez avec Nous', card3Desc: 'Rejoignez notre programme de partenaires.', card3Cta: 'Devenir Partenaire',
    finalTitle: 'Prêt à Digitaliser Votre Entreprise ?',
    finalDesc: 'Contactez-nous aujourd\'hui et découvrez comment nous pouvons vous aider.',
    finalWhatsapp: 'Contacter par WhatsApp',
    finalSchedule: 'Prendre Rendez-vous',
  },

  politicasPage: {
    seoTitle: 'Politiques & Documents Légaux | Punto Hispano',
    seoDesc: 'Documentation juridique, politiques de confidentialité, cookies et conditions d\'utilisation de Punto Hispano.',
    title: 'Politiques & Documents Légaux',
    subtitle: 'Transparence et conformité réglementaire dans tous nos services',
    commitmentTitle: 'Engagement de Transparence',
    commitmentDesc: 'Chez Punto Hispano, nous nous engageons à maintenir une transparence totale sur notre fonctionnement, le traitement de vos données et vos droits en tant qu\'utilisateur.',
    avisoLegal: 'Mentions Légales',
    avisoLegalDesc: 'Informations sur l\'entité titulaire de ce site, conditions générales d\'utilisation et droits de propriété intellectuelle.',
    privacidad: 'Politique de Confidentialité',
    privacidadDesc: 'Informations détaillées sur la collecte, l\'utilisation, le partage et la protection de vos données personnelles.',
    cookies: 'Politique de Cookies',
    cookiesDesc: 'Informations sur les cookies utilisés, leur finalité et comment configurer vos préférences.',
    gdpr: 'Politique RGPD',
    gdprDesc: 'Informations complètes sur la protection des données personnelles selon le RGPD et vos droits.',
    questionTitle: 'Avez-vous des questions supplémentaires ?',
    questionDesc: 'Pour toute question sur nos politiques, contactez notre Délégué à la Protection des Données à',
    lastUpdate: 'Dernière mise à jour de nos politiques : 5 mai 2025',
  },

  faqPage: {
    seoTitle: 'Questions Fréquentes | Punto Hispano',
    seoDesc: 'Réponses aux questions les plus fréquentes sur nos services en Suisse.',
    title: 'Questions Fréquentes',
    subtitle: 'Réponses aux questions les plus courantes sur nos services',
    notFound: 'Vous ne trouvez pas de réponse ? N\'hésitez pas à nous contacter.',
    phone: 'Téléphone',
    email: 'Email',
    cat1: 'Général',
    cat2: 'Gestion & Administration',
    cat3: 'Conseil Juridique',
    cat4: 'Cours de Langues',
    cat5: 'Traductions Officielles',
    cat6: 'Design Web & Hébergement',
    cat7: 'Conseil en Assurances',
    cat8: 'Solutions Digitales',
    q1_1: 'Quels services propose Punto Hispano ?', a1_1: 'Punto Hispano propose une large gamme de services professionnels : gestion administrative, conseil juridique, cours de langues, traductions officielles, design web, conseil en assurances et solutions digitales.',
    q1_2: 'Dans quelles langues proposez-vous vos services ?', a1_2: 'Nos services sont principalement disponibles en espagnol, mais nous servons également en allemand, anglais et italien.',
    q1_3: 'Comment puis-je demander un devis ?', a1_3: 'Vous pouvez demander un devis via notre formulaire de contact, par téléphone au +41 77 231 72 88 ou par email à info@puntohispano.ch.',
    q1_4: 'Avez-vous des services personnalisés pour les entreprises ?', a1_4: 'Oui, nous proposons des solutions sur mesure pour les entreprises dans tous nos domaines de service.',
    q1_5: 'Où se trouve votre bureau principal ?', a1_5: 'Notre bureau principal est situé à Thurgauerstrasse 117, 8152 Opfikon, Zurich, Suisse.',
    q2_1: 'Que comprend le service de création d\'entreprise ?', a2_1: 'Notre service comprend le conseil sur la forme juridique, la préparation des documents, le registre du commerce, l\'inscription fiscale et les démarches de sécurité sociale.',
    q2_2: 'Comment fonctionne la planification fiscale ?', a2_2: 'Nous réalisons une analyse personnalisée de votre situation fiscale et vous conseillons sur les déductions et avantages fiscaux applicables.',
    q2_3: 'Pouvez-vous gérer ma déclaration d\'impôts ?', a2_3: 'Oui, nous offrons un service complet de gestion des déclarations fiscales pour les particuliers.',
    q3_1: 'Quels documents faut-il pour le regroupement familial ?', a3_1: 'Le regroupement familial nécessite généralement : permis de séjour, actes de mariage/naissance légalisés, preuve de moyens financiers suffisants et contrat de bail.',
    q3_2: 'Proposez-vous du conseil en droit du travail suisse ?', a3_2: 'Oui, nous fournissons un conseil complet en droit du travail suisse, incluant révision de contrats, licenciements et litiges.',
    q4_1: 'Quel est le prix des cours d\'allemand ?', a4_1: 'Les prix varient selon le niveau et la modalité. De CHF 40/heure en groupe à CHF 90/session en privé.',
    q4_2: 'Puis-je avoir un cours d\'essai ?', a4_2: 'Oui, nous offrons un cours d\'essai gratuit pour découvrir notre méthodologie.',
    q5_1: 'Vos traductions sont-elles valables pour les démarches officielles ?', a5_1: 'Oui, nos traductions officielles sont réalisées par des traducteurs assermentés et sont valables auprès des organismes officiels.',
    q5_2: 'Combien de temps prend une traduction assermentée ?', a5_2: 'Les documents standard prennent généralement 2-3 jours ouvrables. Service express disponible pour les urgences.',
    q6_1: 'Que comprend le forfait site web professionnel ?', a6_1: 'Il comprend : design personnalisé de 5-7 pages, design responsive, SEO de base, intégration Analytics, formulaire de contact, hébergement un an et maintenance 3 mois.',
    q6_2: 'Puis-je mettre à jour mon site moi-même ?', a6_2: 'Oui, nous implémentons un CMS qui vous permet de mettre à jour facilement textes, images et sections.',
    q7_1: 'Comment réduire ma prime d\'assurance maladie ?', a7_1: 'Plusieurs stratégies : ajuster la franchise, choisir un modèle HMO, vérifier les subventions cantonales ou combiner différentes couvertures.',
    q7_2: 'Quelles assurances sont obligatoires en Suisse ?', a7_2: 'L\'assurance maladie de base (LAMal) est obligatoire pour tous les résidents. L\'assurance responsabilité civile est obligatoire pour les propriétaires de véhicules.',
    q8_1: 'Qu\'est-ce qu\'un CRM et comment peut-il aider mon entreprise ?', a8_1: 'Un CRM permet de gérer centralement les relations clients avec des avantages comme une meilleure organisation des données et l\'automatisation des ventes.',
    q8_2: 'Quelles solutions IA proposez-vous aux petites entreprises ?', a8_2: 'Nous proposons des chatbots 24/7, l\'automatisation des tâches administratives, l\'analyse prédictive et des assistants virtuels de planification.',
  },

  contactoPage: {
    seoTitle: 'Contact | Administration & Conseil en Suisse | Punto Hispano',
    seoDesc: 'Écrivez-nous par WhatsApp ou email ou réservez un rendez-vous à Zurich. Réponse rapide.',
    heroTitle: 'Parlons-en',
    heroDesc: 'Notre équipe de professionnels bilingues est prête à répondre à vos besoins. Choisissez votre méthode de contact préférée.',
    whatsappBtn: 'WhatsApp Direct',
    formBtn: 'Formulaire de Contact',
    formTitle: 'Formulaire de Contact',
    successTitle: 'Message Envoyé !',
    successDesc: 'Merci de nous avoir contactés. Nous avons reçu votre message et vous répondrons sous 24 heures.',
    sendAnother: 'Envoyer un autre message',
    labelName: 'Nom Complet',
    placeholderName: 'Entrez votre nom complet',
    labelEmail: 'Adresse Email',
    placeholderEmail: 'votre.email@exemple.com',
    labelPhone: 'Téléphone (optionnel)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelService: 'Domaine de Service',
    selectService: 'Sélectionnez un domaine',
    optGestoria: 'Administration & Fiscalité',
    optLegal: 'Conseil Juridique',
    optIdiomas: 'Cours de Langues',
    optSeguros: 'Assurances & Prévoyance',
    optDigital: 'Solutions Digitales',
    optOther: 'Autre',
    labelMessage: 'Votre Message',
    placeholderMessage: 'Dites-nous comment nous pouvons vous aider...',
    sending: 'Envoi en cours...',
    sendBtn: 'Envoyer le Message',
    toastSuccess: 'Formulaire envoyé',
    toastSuccessDesc: 'Nous avons reçu votre message. Nous vous contacterons bientôt.',
    toastError: "Erreur d'envoi",
    toastErrorDesc: "Un problème est survenu lors de l'envoi. Veuillez réessayer.",
    infoTitle: 'Informations de Contact',
    infoDesc: 'Notre équipe multilingue est prête à vous assister en français, espagnol et anglais.',
    officeTitle: 'Notre Bureau',
    phoneTitle: 'Téléphone',
    whatsappTitle: 'WhatsApp Direct',
    emailTitle: 'Email',
    hoursTitle: "Heures d'Ouverture",
    monFri: 'Lundi - Vendredi',
    sat: 'Samedi',
    sun: 'Dimanche',
    closed: 'Fermé',
    needHelp: "Besoin d'aide immédiate ?",
    needHelpDesc: 'Contactez-nous directement par WhatsApp pour une assistance rapide',
    validName: 'Le nom doit contenir au moins 2 caractères',
    validEmail: 'Veuillez entrer une adresse email valide',
    validService: 'Veuillez sélectionner un domaine de service',
    validMessage: 'Le message doit contenir au moins 10 caractères',
  },

  contactoFormPage: {
    seoTitle: 'Formulaire de Contact | Punto Hispano',
    seoDesc: 'Contactez-nous pour vos demandes. Nous répondons sous 24-48 heures ouvrables.',
    title: 'Formulaire de Contact',
    subtitle: 'Remplissez le formulaire ci-dessous pour nous envoyer votre demande. Notre équipe vous répondra dans les meilleurs délais.',
    successTitle: 'Message Envoyé !',
    successDesc: 'Merci de nous avoir contactés. Nous vous répondrons sous 24-48 heures ouvrables.',
    sendAnother: 'Envoyer un autre message',
    labelName: 'Nom complet',
    placeholderName: 'Entrez votre nom',
    labelEmail: 'Adresse email',
    labelPhone: 'Téléphone (optionnel)',
    placeholderPhone: 'Votre numéro de téléphone',
    labelService: 'Domaine de service',
    selectService: 'Sélectionnez un domaine',
    optGestoria: 'Administration',
    optLegal: 'Conseil Juridique',
    optIdiomas: 'Cours de Langues',
    optSeguros: 'Assurances & Prévoyance',
    optDigital: 'Solutions Digitales',
    optCoches: 'Location de Voitures',
    optViviendas: 'Location de Logements',
    labelMessage: 'Message',
    placeholderMessage: 'Comment pouvons-nous vous aider ?',
    sending: 'Envoi...',
    sendBtn: 'Envoyer le Message',
    privacyText: 'En soumettant ce formulaire, vous acceptez notre',
    privacyLink: 'politique de confidentialité',
    privacyEnd: 'et le traitement de vos données pour répondre à votre demande.',
    fastResponse: 'Réponse rapide',
    fastResponseDesc: '24-48h ouvrables',
    noCommitment: 'Sans engagement',
    noCommitmentDesc: 'Devis personnalisés',
    spanishSupport: 'Support multilingue',
    spanishSupportDesc: 'Équipe multilingue professionnelle',
  },

  oficinasPage: {
    seoTitle: 'Bureau Opfikon | Punto Hispano',
    seoDesc: 'Visitez notre bureau à Opfikon, Zurich. Emplacement, horaires, transport.',
    heroTitle: 'Notre Bureau à Opfikon',
    heroDesc: 'Visitez-nous au centre commercial TMC, à quelques minutes du centre de Zurich.',
    howToFind: 'Comment Nous Trouver — Étape par Étape',
    step1Title: 'Cherchez le bâtiment TMC',
    step1Desc: "C'est un centre commercial à la Thurgauerstrasse 117. Vous verrez l'enseigne \"TMC\" sur la façade.",
    step2Title: 'Entrez et allez tout droit',
    step2Desc: "Entrez par la porte principale et allez tout droit jusqu'à ce que vous voyiez un café.",
    step3Title: 'Montez au 1er étage',
    step3Desc: "À côté du café, vous trouverez l'ascenseur. Montez au premier étage.",
    step4Title: 'Tournez à droite',
    step4Desc: "En sortant de l'ascenseur, tournez à droite. Notre bureau est le 181.",
    tmcNote: 'Nous sommes situés dans le TMC (Trade Mart Center), un bâtiment de showrooms et bureaux.',
    enlargeMap: 'Agrandir la Carte',
    addressTitle: 'Adresse',
    phoneTitle: 'Téléphone',
    emailTitle: 'Email',
    hoursTitle: "Heures d'Ouverture",
    appointmentsTitle: 'Rendez-vous',
    appointmentsDesc: 'Pour un meilleur service, nous recommandons de prendre rendez-vous.',
    requestAppointment: 'Demander un Rendez-vous',
    howToGet: 'Comment Venir',
    train: 'Train',
    trainDesc: 'Gare de Opfikon, 5 minutes à pied',
    bus: 'Bus',
    busDesc: 'Lignes 759, 781 - Arrêt Thurgauerstrasse',
    car: 'Voiture',
    carDesc: 'Parking disponible dans le bâtiment',
    airport: "Depuis l'aéroport",
    airportDesc: '10 minutes en taxi ou bus direct',
    parkingTitle: 'Parking',
    parkingDesc: 'Le bâtiment TMC dispose de parking horaire pour clients. Alternativement, parking public à proximité.',
    additionalInfo: 'Informations Supplémentaires',
    accessibilityTitle: 'Accessibilité',
    accessibilityDesc: "Nos bureaux sont accessibles aux personnes à mobilité réduite. Le bâtiment dispose d'ascenseurs et de rampes.",
    walkInsTitle: 'Visites sans rendez-vous',
    walkInsDesc: 'Nous recommandons de prendre rendez-vous, mais acceptons les visites selon disponibilité.',
    nearbyTitle: 'Services à proximité',
    nearbyDesc: 'Dans le bâtiment TMC, vous trouverez un café où attendre confortablement.',
    otherContactTitle: "Préférez-vous nous contacter autrement ?",
    otherContactDesc: "Si vous ne pouvez pas nous rendre visite, d'autres options de contact sont disponibles.",
    contactForm: 'Formulaire de Contact',
    whatsappChat: 'WhatsApp & Chat',
    days: ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'],
    satHours: '10:00 - 14:00 (sur rendez-vous)',
    closed: 'Fermé',
  },

  quienesSomosPage: {
    seoTitle: 'Qui Sommes-Nous - Punto Hispano | Services Professionnels en Suisse',
    seoDesc: 'Découvrez Punto Hispano : 12+ ans au service de la communauté en Suisse. Administration, assurances, juridique, langues et services digitaux.',
    badge: 'À Propos',
    heroTitle: 'Punto Hispano :',
    heroAccent: 'Votre pont entre la Suisse et le monde',
    heroDesc: 'Depuis 2013, nous facilitons l\'intégration et le succès en Suisse.',
    stat1: 'Clients Satisfaits',
    stat2: 'Procédures Complétées',
    stat3: 'Entreprises Créées',
    stat4: "Années d'Expérience",
    missionBtn: 'Notre Mission & Vision',
    contactBtn: 'Nous Contacter',
    teamPhoto: 'Notre Équipe',
    teamPhotoDesc: 'Des professionnels dédiés à votre réussite',
    historyTitle: 'Notre Histoire',
    historySubtitle: "Un parcours de croissance et d'engagement",
    historyDesc: 'Découvrez comment Punto Hispano a évolué de ses débuts pour devenir la référence en Suisse.',
    timeline2013Title: 'Les débuts',
    timeline2013Desc: 'Santiago Castillo, le fondateur, a commencé en Suisse avec les assurances et le 3e pilier.',
    timeline2019Title: 'Services sans bureau',
    timeline2019Desc: 'Punto Hispano a commencé à offrir des services professionnels.',
    timeline2023Title: 'Ouverture du bureau',
    timeline2023Desc: 'Punto Hispano a ouvert son bureau physique, un jalon important.',
    timeline2025Title: 'Expansion continue',
    timeline2025Desc: 'Nous continuons à élargir nos services et à consolider notre position de référence.',
    teamTitle: 'Notre Équipe & Bureau',
    teamSubtitle: 'Les personnes derrière Punto Hispano',
    teamDesc: 'Rencontrez Santiago Castillo, notre fondateur, et l\'équipe professionnelle.',
    founderBadge: 'Fondateur',
    valuesTitle: 'Nos Valeurs',
    valuesSubtitle: 'Les principes qui nous guident',
    valuesDesc: 'Chaque valeur représente un engagement réel envers nos clients et la communauté.',
    val1Title: 'Proximité',
    val1Desc: 'Attention personnalisée et adaptée à chaque client.',
    val2Title: 'Professionnalisme',
    val2Desc: 'Rigueur, excellence et amélioration continue.',
    val3Title: 'Transparence',
    val3Desc: 'Communication claire et honnête.',
    val4Title: 'Innovation',
    val4Desc: 'Recherche constante de solutions créatives et efficaces.',
    val5Title: 'Engagement',
    val5Desc: 'Dévouement absolu à la satisfaction et au succès des clients.',
    val6Title: 'Intégration',
    val6Desc: 'Nous facilitons le lien entre les cultures.',
    ctaTitle: 'Prêt à faire le premier pas ?',
    ctaDesc: "Contactez-nous aujourd'hui pour une consultation gratuite.",
    ctaBtn: 'Demander une Consultation Gratuite',
    ctaSecondary: 'Voir Nos Services',
  },

  misionVisionPage: {
    seoTitle: 'Mission & Vision - Punto Hispano | Leader en Services Professionnels en Suisse',
    seoDesc: 'Découvrez la mission, la vision et les valeurs de Punto Hispano : 12+ ans en tête des services professionnels en Suisse.',
    badge: 'Notre Objectif',
    heroTitle: 'Mission &',
    heroAccent: 'Vision',
    heroDesc: 'Découvrez ce qui nous pousse à être la référence en services professionnels en Suisse',
    stat1: 'Clients satisfaits',
    stat2: "Années d'expérience",
    stat3: 'Engagement qualité',
    stat4: 'Piliers de service',
    missionTitle: 'Notre Mission',
    missionSubtitle: 'Ce que nous faisons chaque jour',
    missionText1: 'Fournir des services professionnels complets de la plus haute qualité à la communauté en Suisse.',
    missionText2: 'Nous nous engageons à être un pont fiable entre les cultures.',
    missionPoints: ['Services professionnels complets', 'Nous facilitons l\'intégration en Suisse', 'Développement professionnel et bien-être personnel', 'Solutions efficaces et personnalisées', 'Pont fiable entre les cultures', 'Accompagnement proche dans votre langue'],
    commitmentTitle: 'Engagement Quotidien',
    commitmentDesc: 'Chaque jour, nous travaillons pour concrétiser notre mission.',
    visionTitle: 'Notre Vision',
    visionSubtitle: 'Vers où nous allons',
    visionText1: 'Être reconnus comme l\'entreprise leader en services professionnels en Suisse.',
    visionText2: 'Nous aspirons à transformer l\'expérience client en Suisse.',
    visionPoints: ['Entreprise leader en services', 'Excellence et innovation technologique', 'Approche humaine et personnalisée', 'Intégration parfaite des services traditionnels et digitaux', 'Écosystème complet de solutions', 'Transformation de l\'expérience client'],
    futureTitle: 'Avenir Brillant',
    futureDesc: 'Nous construisons l\'avenir des services professionnels en Suisse.',
    valuesTitle: 'Des Valeurs qui Nous Définissent',
    valuesSubtitle: 'Les principes fondamentaux qui guident chaque décision.',
    val1Title: 'Proximité',
    val1Desc: 'Traitement personnel et humain',
    val2Title: 'Confiance',
    val2Desc: 'Transparence totale',
    val3Title: 'Excellence',
    val3Desc: 'Qualité supérieure',
    val4Title: 'Innovation',
    val4Desc: 'Technologie avancée',
    ctaTitle: 'Prêt à faire partie de notre histoire ?',
    ctaDesc: 'Rejoignez plus de 2500 clients qui font confiance à Punto Hispano.',
    ctaBtn: 'Consultation Gratuite',
    ctaSecondary: 'Voir les Services',
  },

  valoresPage: {
    seoTitle: 'Valeurs d\'Entreprise - Punto Hispano | Excellence, Confiance & Innovation',
    seoDesc: 'Découvrez les valeurs fondamentales de Punto Hispano : excellence, confiance, spécialisation, intégrité, innovation et empathie.',
    badge: 'Notre Philosophie',
    heroTitle: 'Nos',
    heroAccent: 'Valeurs',
    heroDesc: 'Les principes fondamentaux qui définissent notre identité et guident chaque décision.',
    stat1: "Années d'expérience",
    stat2: 'Clients satisfaits',
    stat3: 'Piliers de service',
    stat4: 'Engagement qualité',
    val1Title: 'Excellence',
    val1Desc: 'Nous recherchons la plus haute qualité dans chaque service.',
    val2Title: 'Confiance',
    val2Desc: 'Nous construisons des relations durables basées sur la transparence et l\'honnêteté.',
    val3Title: 'Spécialisation',
    val3Desc: 'Nous maintenons une connaissance approfondie et actualisée de nos domaines de service.',
    val4Title: 'Intégrité',
    val4Desc: 'Nous agissons avec rectitude et éthique professionnelle.',
    val5Title: 'Innovation',
    val5Desc: 'Nous intégrons constamment de nouvelles technologies et méthodes.',
    val6Title: 'Empathie',
    val6Desc: 'Nous comprenons les besoins et circonstances uniques de chaque client.',
    learnMore: 'En savoir plus',
    commitmentTitle: 'Notre Engagement Inébranlable',
    commitmentText1: 'Chez Punto Hispano, ces valeurs ne sont pas de simples mots, mais des principes vivants.',
    commitmentText2: 'Nous nous engageons fermement à maintenir les plus hauts standards de qualité et d\'éthique professionnelle.',
    promiseLabel: 'Notre promesse :',
    promiseText: 'Chaque jour, nous travaillons pour être la référence de confiance, d\'excellence et de proximité que la communauté en Suisse mérite et a besoin.',
    meetTeam: 'Rencontrer notre équipe',
    actionTitle: 'Valeurs en Action',
    actionSubtitle: 'Découvrez comment nos valeurs se traduisent en avantages tangibles.',
    qualityTitle: 'Garantie de Qualité',
    qualityDesc: 'Notre engagement envers l\'excellence se reflète dans chaque service.',
    qualityItems: ['Attention personnalisée et dédiée', 'Suivi continu de tous les processus', 'Transparence totale dans notre gestion'],
    closenessTitle: 'Proximité Humaine',
    closenessDesc: 'Nous comprenons que derrière chaque procédure, il y a une personne avec des rêves et des besoins uniques.',
    closenessItems: ['Communication dans votre langue maternelle', 'Compréhension de votre culture et contexte', 'Soutien émotionnel dans les processus complexes'],
  },

  carrerasPage: {
    seoTitle: 'Travaillez avec Nous chez Punto Hispano Suisse',
    seoDesc: 'Découvrez les opportunités de carrière chez Punto Hispano : administration, juridique, langues, assurances et digital.',
    badge: 'Opportunités de Carrière',
    heroTitle: 'Travaillez avec',
    heroAccent: 'Nous',
    heroDesc: 'Rejoignez l\'équipe leader en services professionnels en Suisse.',
    stat1: 'Clients satisfaits',
    stat2: "Années d'expérience",
    stat3: 'Professionnels + collaborateurs externes',
    stat4: 'Domaines de spécialisation',
    benefitsTitle: 'Pourquoi choisir Punto Hispano ?',
    benefitsSubtitle: 'Découvrez les avantages de faire partie de notre équipe professionnelle',
    ben1Title: 'Environnement Multiculturel',
    ben1Desc: 'Travaillez dans un environnement collaboratif avec des professionnels de diverses nationalités',
    ben2Title: 'Croissance Professionnelle',
    ben2Desc: 'Véritables opportunités de développement et de promotion interne',
    ben3Title: 'Formation Continue',
    ben3Desc: 'Soutien pour les certifications et le développement professionnel constant',
    ben4Title: 'Équilibre Vie-Travail',
    ben4Desc: 'Horaires flexibles et respect de votre temps personnel',
    ben5Title: 'Avantages Sociaux',
    ben5Desc: 'Assurance maladie, plans de prévoyance et avantages supplémentaires',
    ben6Title: 'Reconnaissance',
    ben6Desc: 'Système d\'incitations et reconnaissance pour performance exceptionnelle',
    joinTitle: 'Rejoignez l\'Équipe',
    joinSubtitle: 'Votre prochaine opportunité professionnelle vous attend',
    joinText1: 'Chez Punto Hispano, nous cherchons des talents engagés avec une attitude positive et une vocation de service.',
    joinText2: 'Faites partie de l\'entreprise leader en services professionnels en Suisse.',
    processTitle: 'Processus de Sélection :',
    processSteps: ['Envoi du CV et lettre de motivation', 'Examen des candidatures et présélection', 'Entretien initial avec les RH', 'Entretien technique avec l\'équipe', 'Proposition d\'embauche'],
    sendCV: 'Envoyez votre CV',
    areasTitle: 'Domaines de Spécialisation',
    areasSubtitle: 'Découvrez les différents domaines où vous pouvez développer votre carrière',
    area1Title: 'Administration Fiscale',
    area1Desc: 'Spécialistes en déclarations fiscales, comptabilité et conseil fiscal.',
    area1Req: 'Expérience en fiscalité suisse/internationale, diplôme en gestion ou similaire.',
    area2Title: 'Conseil Juridique',
    area2Desc: 'Juristes spécialisés en immigration, droit du travail, civil et commercial.',
    area2Req: 'Diplôme en droit, expérience en conseil juridique international.',
    area3Title: 'Enseignement des Langues',
    area3Desc: 'Enseignants natifs pour cours individuels et collectifs.',
    area3Req: 'Diplôme officiel d\'enseignement des langues, certifications (DELE, Goethe, Cambridge).',
    area4Title: 'Conseil en Assurances',
    area4Desc: 'Conseillers spécialisés en assurance maladie, vie et plans de retraite.',
    area4Req: 'Certification de conseiller en assurances, expérience sur le marché suisse.',
    area5Title: 'Développement Digital',
    area5Desc: 'Designers et développeurs web, spécialistes UX/UI et marketing digital.',
    area5Req: 'Formation technique, portfolio de projets, connaissances actualisées.',
    area6Title: 'Ventes & Marketing',
    area6Desc: 'Professionnels focalisés sur l\'acquisition de clients et les stratégies de positionnement.',
    area6Req: 'Expérience commerciale B2B, compétences communicationnelles exceptionnelles.',
    reqLabel: 'Prérequis :',
  },

  notFoundPage: {
    title: 'Page non trouvée',
    desc: 'Désolé, la page que vous cherchez n\'existe pas ou a été déplacée.',
    goHome: "Retour à l'accueil",
  },

  recursosPage: {
    seoTitle: 'Ressources Gratuites | Guides, Outils & Webinaires | Punto Hispano',
    seoDesc: 'Accédez à des guides, calculateurs, webinaires et ressources gratuits pour votre succès en Suisse.',
    heroTitle: 'Centre de Ressources',
    heroSubtitle: 'Outils, guides et matériaux gratuits pour votre succès en Suisse',
    searchPlaceholder: 'Rechercher des ressources...',
    filterAll: 'Tous',
    filterGuides: 'Guides',
    filterCalculators: 'Calculateurs',
    filterWebinars: 'Webinaires',
    filterVideos: 'Vidéos',
    filterTemplates: 'Modèles',
    categoryAll: 'Toutes les catégories',
    categoryLegal: 'Juridique',
    categoryFiscal: 'Fiscal',
    categorySeguros: 'Assurances',
    categoryIdiomas: 'Langues',
    categoryDigital: 'Digital',
    sortPopular: 'Plus populaires',
    sortRecent: 'Plus récents',
    sortRating: 'Mieux notés',
    downloads: 'téléchargements',
    pages: 'pages',
    downloadBtn: 'Télécharger',
    previewBtn: 'Aperçu',
    featured: 'En vedette',
    new: 'Nouveau',
    noResults: 'Aucune ressource trouvée avec les filtres sélectionnés.',
    clearFilters: 'Réinitialiser les filtres',
    newsletterTitle: 'Vous souhaitez recevoir de nouvelles ressources ?',
    newsletterDesc: 'Abonnez-vous et recevez guides et outils directement par email.',
    newsletterBtn: "S'abonner",
    emailPlaceholder: 'votre@email.com',
  },

  guiasPracticasPage: {
    seoTitle: 'Guides Pratiques | Ressources | Punto Hispano',
    seoDesc: 'Guides détaillés sur les procédures et démarches en Suisse.',
    title: 'Guides Pratiques',
    subtitle: 'Informations utiles pour vos démarches et procédures',
    readTime: 'Temps de lecture',
    readGuide: 'Lire le guide',
    faqTitle: 'Questions Fréquentes sur nos Guides',
  },

  whitepapersPage: {
    seoTitle: 'Whitepapers | Ressources Professionnelles | Punto Hispano',
    seoDesc: 'Téléchargez nos whitepapers spécialisés en fiscalité, droit et transformation digitale.',
    title: 'Whitepapers',
    subtitle: 'Documents techniques et guides professionnels',
    pages: 'pages',
    published: 'Publié',
    downloadPdf: 'Télécharger le PDF',
    faqTitle: 'Questions Fréquentes sur nos Whitepapers',
  },

  videosWebinarsPage: {
    seoTitle: 'Vidéos & Webinaires | Ressources Audiovisuelles | Punto Hispano',
    seoDesc: 'Accédez à nos webinaires et contenus audiovisuels sur les démarches, impôts et vie en Suisse.',
    title: 'Vidéos & Webinaires',
    subtitle: 'Contenu audiovisuel éducatif et professionnel',
    upcoming: 'À venir',
    past: 'Passés',
    register: "S'inscrire",
    watchNow: 'Regarder',
    duration: 'Durée',
    faqTitle: 'Questions Fréquentes sur nos Webinaires',
  },

  colaboraPage: {
    seoTitle: 'Programme Partners et Collaborateurs | Punto Hispano',
    seoDesc: 'Rejoignez notre programme partenaire : affiliés, partenaires technologiques et agences.',
    heroTitle: 'Programme Partners et Collaborateurs',
    heroDesc: 'Rejoignez notre écosystème et grandissez ensemble.',
    backToEmprende: 'Retour à Emprende',
    whyPartner: 'Pourquoi devenir Partenaire ?',
    whyPartnerDesc: 'Avantages exclusifs de rejoindre notre écosystème de collaboration.',
    ben1Title: 'Commissions Attractives',
    ben1Desc: 'Gagnez des commissions compétitives pour chaque référence ou projet commun.',
    ben2Title: 'Support Dédié',
    ben2Desc: "Équipe de support exclusive pour les partenaires avec priorité.",
    ben3Title: 'Formation Continue',
    ben3Desc: 'Accès à des ressources et formations exclusives pour les partenaires.',
    ben4Title: 'Croissance Commune',
    ben4Desc: 'Développez votre activité aux côtés de la nôtre avec des synergies réelles.',
    ctaTitle: 'Prêt à devenir notre Partenaire ?',
    ctaBtn: 'Demander un Partenariat',
    ctaWhatsapp: 'Demander par WhatsApp',
  },

  ganaDineroPage: {
    seoTitle: "Gagner de l'Argent en Ligne | Stratégies Digitales | Punto Hispano",
    seoDesc: 'Apprenez à monétiser vos compétences et créer des revenus digitaux depuis la Suisse.',
    heroTitle: "Gagner de l'Argent en Ligne",
    heroDesc: 'Stratégies éprouvées pour générer des revenus dans le monde digital.',
    backToEmprende: 'Retour à Emprende',
    strategiesTitle: 'Stratégies pour Générer des Revenus',
    strategiesDesc: "Découvrez les meilleures façons de gagner de l'argent en ligne.",
    tipsLabel: 'Conseils clés :',
    ctaTitle: "Besoin d'aide pour commencer ?",
    ctaDesc: 'Nous vous conseillons pour lancer votre activité digitale.',
    ctaBtn: 'Consultation Gratuite',
    ctaWhatsapp: 'WhatsApp',
  },

  transmiteIdeasPage: {
    seoTitle: 'Soumettez Votre Idée de Projet | Punto Hispano',
    seoDesc: 'Parlez-nous de votre idée de projet digital et nous vous aiderons à la concrétiser.',
    heroTitle: 'Parlez-nous de Votre Idée',
    heroDesc: 'Décrivez votre projet et notre équipe vous conseillera sur la meilleure approche.',
    backToEmprende: 'Retour à Emprende',
    formTitle: 'Décrivez votre projet',
    labelName: 'Nom complet',
    placeholderName: 'Votre nom',
    labelEmail: 'Adresse email',
    labelPhone: 'Téléphone (optionnel)',
    placeholderPhone: '+41 XX XXX XX XX',
    labelProjectType: 'Type de projet',
    labelDescription: 'Décrivez votre idée',
    placeholderDescription: 'Racontez-nous les détails de votre projet...',
    labelBudget: 'Budget estimé',
    labelUrgency: 'Urgence',
    labelFeatures: 'Fonctionnalités requises',
    submitBtn: "Soumettre l'Idée",
    sending: 'Envoi...',
    successTitle: 'Idée Reçue !',
    successDesc: 'Nous avons reçu votre proposition. Nous vous contacterons pour évaluer votre projet.',
    sendAnother: 'Soumettre une autre idée',
    guaranteeTitle: 'Notre engagement',
    guarantee1: 'Réponse en 24-48h',
    guarantee2: 'Évaluation gratuite',
    guarantee3: 'Sans engagement',
    guarantee4: 'Devis détaillé',
  },

  authPage: {
    loginTitle: 'Connexion',
    loginDesc: 'Accédez à votre compte Punto Hispano.',
    signupTitle: 'Créer un Compte',
    signupDesc: 'Inscrivez-vous pour accéder à tous nos services.',
    email: 'Adresse email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    name: 'Nom complet',
    loginBtn: 'Se Connecter',
    signupBtn: 'Créer le Compte',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: "Pas de compte ?",
    hasAccount: 'Déjà un compte ?',
    signupLink: "S'inscrire",
    loginLink: 'Se connecter',
    orContinueWith: 'Ou continuer avec',
    google: 'Google',
    resetTitle: 'Réinitialiser le Mot de Passe',
    resetDesc: 'Entrez votre email et nous vous enverrons un lien de réinitialisation.',
    resetBtn: 'Envoyer le lien',
    resetSuccess: 'Nous avons envoyé un lien à votre email.',
    backToLogin: 'Retour à la connexion',
  },

  avisoLegalPage: {
    seoTitle: 'Mentions Légales | Punto Hispano',
    seoDesc: 'Informations légales complètes sur Punto Hispano et ses services.',
    title: 'Mentions Légales',
    subtitle: 'Informations légales complètes sur Punto Hispano et nos services',
    whatIs: 'Qu\'est-ce que ces mentions légales ?',
    whatIsP1: 'Ces mentions légales régissent l\'utilisation du site web www.puntohispano.ch, dont le propriétaire est Punto Hispano GmbH, une société enregistrée en Suisse.',
    whatIsP2: 'En naviguant sur notre site web, vous acceptez toutes les conditions qui y sont établies. Nous vous recommandons de lire attentivement ces informations.',
    whoWeAre: 'Qui sommes-nous ?',
    idData: 'Données d\'identification',
    company: 'Entreprise',
    companySubtitle: 'Gestion & Conseil en Suisse',
    officialAddress: 'Adresse officielle',
    contactTitle: 'Comment nous contacter ?',
    digitalComm: 'Communication numérique',
    directComm: 'Communication directe',
    mainEmail: 'E-mail principal :',
    website: 'Site web :',
    phone: 'Téléphone :',
    officeHours: 'Horaires d\'ouverture :',
    weekdayHours: 'Lundi au vendredi : 9h00 - 18h00',
    saturdayHours: 'Samedis : 10h00 - 14h00',
    termsTitle: 'Conditions d\'utilisation du site web',
    term1Title: '1. Acceptation des conditions',
    term1Desc: 'En accédant et en utilisant ce site web, vous acceptez automatiquement d\'être soumis à ces conditions d\'utilisation.',
    term2Title: '2. Utilisation autorisée',
    term2Desc: 'Ce site web est destiné exclusivement à :',
    term2Items: ['Obtenir des informations sur nos services', 'Demander des consultations et des devis', 'Contacter notre équipe professionnelle', 'Accéder aux ressources et à la documentation'],
    term3Title: '3. Utilisation interdite',
    term3Warning: 'Il est strictement interdit de :',
    term3Items: ['Utiliser le site pour des activités illégales', 'Tenter d\'accéder à des zones restreintes', 'Copier ou reproduire du contenu sans autorisation', 'Envoyer des informations fausses ou trompeuses', 'Interférer avec le fonctionnement du site'],
    ipTitle: 'Propriété intellectuelle et industrielle',
    ipProtected: 'Qu\'est-ce qui est protégé ?',
    ipDesc: 'Tous les éléments de ce site web sont protégés par les lois suisses sur la propriété intellectuelle et industrielle.',
    ipVisual: 'Éléments visuels',
    ipVisualItems: ['Design et mise en page', 'Logos et marques', 'Images et photographies', 'Icônes et graphiques'],
    ipTechnical: 'Éléments techniques',
    ipTechnicalItems: ['Code de programmation', 'Base de données', 'Architecture web', 'Fonctionnalités'],
    ipWarning: 'La reproduction, la distribution ou toute forme d\'exploitation du contenu de ce site sans autorisation est expressément interdite.',
    responsibilityTitle: 'Responsabilités et limitations',
    ourCommitment: 'Notre engagement',
    ourCommitmentDesc: 'Punto Hispano s\'engage à maintenir ce site web opérationnel. Cependant, nous ne pouvons pas garantir :',
    ourCommitmentItems: ['La disponibilité continue 24h/24 et 7j/7', 'L\'absence totale d\'erreurs techniques', 'La compatibilité avec tous les navigateurs', 'La protection absolue contre les cyberattaques'],
    userResponsibility: 'Responsabilité de l\'utilisateur',
    userResponsibilityDesc: 'En tant qu\'utilisateur, vous êtes responsable de :',
    userResponsibilityItems: ['Fournir des informations véridiques', 'Maintenir la confidentialité de vos identifiants', 'Utiliser le site de manière responsable et légale', 'Respecter les droits de propriété intellectuelle'],
    lawTitle: 'Droit applicable et juridiction',
    applicableLaw: 'Droit applicable',
    applicableLawDesc: 'Ces mentions légales sont régies par le droit suisse, Canton de Zürich.',
    jurisdiction: 'Juridiction compétente',
    jurisdictionDesc: 'Les parties se soumettent à la juridiction des tribunaux de Zürich, Suisse.',
    faqTitle: 'Questions juridiques fréquentes',
    faqMoreInfo: 'Besoin d\'informations juridiques ? Contactez nos experts pour une consultation personnalisée',
    relatedPolicies: 'Politiques associées',
    dataProtection: 'Protection des données',
    dataProtectionDesc: 'Découvrez comment nous protégeons vos informations personnelles',
    cookiePolicyLink: 'Politique de cookies',
    cookiePolicyDesc: 'Informations sur l\'utilisation des cookies',
    privacyPolicyLink: 'Politique de confidentialité',
    privacyPolicyDesc: 'Conditions générales de confidentialité',
    legalQuestions: 'Questions juridiques ?',
    legalQuestionsDesc: 'N\'hésitez pas à nous contacter pour toute question.',
    lastUpdated: 'Dernière mise à jour :',
    lastUpdatedDate: '24 juin 2025',
  },
  politicaPrivacidadPage: {
    seoTitle: 'Politique de Confidentialité | Protection des Données | Punto Hispano',
    seoDesc: 'Politique de confidentialité complète de Punto Hispano. Découvrez comment nous collectons, utilisons et protégeons vos données personnelles.',
    titlePart1: 'Politique de',
    titlePart2: 'Confidentialité',
    subtitle: 'Votre vie privée est fondamentale. Découvrez comment nous protégeons vos informations avec les plus hauts standards de sécurité.',
    gdprBadge: 'Conforme au RGPD',
    encryptionBadge: 'Chiffrement AES-256',
    isoBadge: 'ISO 27001',
    introTitle: 'Pourquoi votre vie privée est-elle importante ?',
    introP1Pre: 'Chez',
    introP1Brand: 'Punto Hispano',
    introP1Post: ', nous valorisons et respectons votre vie privée comme un droit fondamental. Cette Politique explique de manière transparente comment nous collectons, utilisons, partageons et protégeons les informations personnelles que vous nous fournissez.',
    introHighlight: 'En utilisant nos services, vous acceptez les pratiques décrites dans cette Politique de Confidentialité.',
    introBadge1: 'Transparence Totale',
    introBadge2: 'Sécurité Maximale',
    introBadge3: 'Contrôle Total',
    whatTitle: 'Quelles informations collectons-nous ?',
    whatIntro: 'Nous collectons différents types d\'informations personnelles afin de vous offrir nos services professionnels au mieux.',
    section1Title: '1. Informations que vous nous fournissez',
    idCardTitle: 'Données d\'identification',
    idCard1: 'Nom et prénom complets',
    idCard2: 'Pièce d\'identité (CNI, NIE, passeport)',
    idCard3: 'Date de naissance et nationalité',
    contactCardTitle: 'Informations de contact',
    contactCard1: 'Adresse email',
    contactCard2: 'Numéros de téléphone mobile et fixe',
    contactCard3: 'Adresse postale complète',
    profCardTitle: 'Données professionnelles',
    profCard1: 'Entreprise où vous travaillez et poste',
    profCard2: 'Secteur d\'activité professionnelle',
    profCard3: 'Informations professionnelles pertinentes',
    finCardTitle: 'Informations financières',
    finCard1: 'Coordonnées bancaires (pour le traitement des paiements)',
    finCard2: 'Informations fiscales nécessaires',
    finCard3: 'Documentation financière pour services spécifiques',
    section2Title: '2. Informations collectées automatiquement',
    autoIntroLabel: 'Que collectons-nous ?',
    autoIntroDesc: 'Lors de votre visite, nous collectons automatiquement certaines informations techniques.',
    autoUseLabel: 'Données d\'utilisation :',
    autoUseDesc: 'pages visitées, temps passé, liens utilisés',
    autoDeviceLabel: 'Informations de l\'appareil :',
    autoDeviceDesc: 'type d\'appareil, système d\'exploitation, navigateur',
    autoLocLabel: 'Informations de localisation :',
    autoLocDesc: 'pays et région (selon votre adresse IP)',
    autoCookiesLabel: 'Cookies :',
    autoCookiesDesc: 'pour plus d\'informations, consultez notre Politique de Cookies',
    useTitle: 'Comment utilisons-nous vos informations ?',
    useIntro: 'Nous utilisons vos données personnelles exclusivement aux fins légitimes suivantes :',
    useServicesTitle: 'Services principaux',
    useService1: 'Fournir et maintenir nos services',
    useService2: 'Traiter les transactions et paiements',
    useService3: 'Gérer votre compte et profil',
    useService4: 'Remplir les obligations contractuelles',
    useCommTitle: 'Communication',
    useComm1: 'Répondre aux demandes',
    useComm2: 'Envoyer des mises à jour de service',
    useComm3: 'Fournir un support technique',
    useComm4: 'Communiquer des informations importantes',
    useImproveTitle: 'Amélioration et analyse',
    useImprove1: 'Personnaliser votre expérience',
    useImprove2: 'Analyser les tendances et l\'utilisation',
    useImprove3: 'Améliorer nos services',
    useImprove4: 'Développer de nouvelles fonctionnalités',
    useSecTitle: 'Sécurité et juridique',
    useSec1: 'Détecter les activités frauduleuses',
    useSec2: 'Respecter les obligations légales',
    useSec3: 'Protéger les droits et la sécurité',
    useSec4: 'Résoudre les litiges juridiques',
    legalTitle: 'Base légale du traitement',
    legalIntro: 'Nous traitons vos données sur les bases légales reconnues suivantes :',
    legal1Title: 'Exécution d\'un contrat',
    legal1Desc: 'Lorsque le traitement est nécessaire pour remplir nos obligations contractuelles.',
    legal2Title: 'Consentement',
    legal2Desc: 'Lorsque vous avez donné votre consentement explicite à un traitement précis.',
    legal3Title: 'Intérêts légitimes',
    legal3Desc: 'Lorsque le traitement est nécessaire à nos intérêts légitimes, sans prévaloir sur vos droits fondamentaux.',
    legal4Title: 'Obligation légale',
    legal4Desc: 'Lorsque le traitement est nécessaire au respect d\'une obligation légale applicable.',
    shareTitle: 'Avec qui partageons-nous vos informations ?',
    shareImportant: 'IMPORTANT : Nous ne vendons pas vos données personnelles à des tiers',
    shareIntro: 'Nous pouvons partager vos données uniquement avec les catégories de destinataires suivantes :',
    share1Title: 'Prestataires de services',
    share1Desc: 'Entreprises qui fournissent des services en notre nom (paiements, analyses, hébergement, support) sous accords stricts de confidentialité.',
    share2Title: 'Partenaires commerciaux',
    share2Desc: 'Tiers avec qui nous collaborons pour des services ou promotions, toujours avec votre accord préalable.',
    share3Title: 'Autorités compétentes',
    share3Desc: 'Lorsque nécessaire pour respecter une obligation légale, une décision judiciaire ou une demande administrative valide.',
    share4Title: 'Transactions d\'entreprise',
    share4Desc: 'Dans le cadre d\'une transaction (fusion, acquisition, vente), en protégeant toujours vos droits.',
    intlTitle: 'Transferts internationaux de données',
    intlIntro: 'Vos données peuvent être transférées vers des pays ayant des lois de protection différentes.',
    intlGuaranteeLabel: 'Garanties de protection :',
    intlGuaranteeDesc: 'Lors de transferts hors EEE ou Suisse, nous garantissons des protections adéquates, comme les clauses contractuelles types approuvées par la Commission européenne.',
    secTitle: 'Comment protégeons-nous vos informations ?',
    secIntro: 'Nous mettons en œuvre des mesures techniques, administratives et physiques pour protéger vos données.',
    secTechTitle: 'Mesures techniques',
    secTech1: 'Chiffrement AES-256 pour le stockage',
    secTech2: 'Communications SSL/TLS sécurisées',
    secTech3: 'Systèmes de détection d\'intrusion',
    secTech4: 'Sauvegardes chiffrées',
    secAdminTitle: 'Mesures administratives',
    secAdmin1: 'Accès limité au personnel autorisé',
    secAdmin2: 'Formation régulière en protection des données',
    secAdmin3: 'Politiques internes de sécurité',
    secAdmin4: 'Audits de sécurité périodiques',
    secLimitsLabel: 'Limitations :',
    secLimitsDesc: 'Bien que nous mettions en œuvre les meilleures mesures, aucun système n\'est totalement impénétrable. Nous ne pouvons garantir une sécurité absolue.',
    retentionTitle: 'Combien de temps conservons-nous vos données ?',
    retentionIntro: 'Nous ne conservons vos données que le temps nécessaire, sauf obligation légale plus longue.',
    ret1Title: 'Documents contractuels',
    ret1Desc: 'Durée du contrat + 6 ans',
    ret2Title: 'Documents fiscaux',
    ret2Desc: '10 ans (loi suisse)',
    ret3Title: 'Communications',
    ret3Desc: '3 ans depuis la dernière interaction',
    ret4Title: 'Données de navigation',
    ret4Desc: 'Maximum 2 ans',
    rightsTitle: 'Quels sont vos droits ?',
    rightsIntro: 'Selon votre lieu de résidence, vous bénéficiez de droits importants sur vos données :',
    rightAccessTitle: 'Droit d\'accès',
    rightAccessDesc: 'Vous pouvez demander des informations sur les données que nous détenons sur vous.',
    rightRectifyTitle: 'Droit de rectification',
    rightRectifyDesc: 'Vous pouvez demander la correction de données inexactes ou incomplètes.',
    rightDeleteTitle: 'Droit à l\'effacement',
    rightDeleteDesc: 'Vous pouvez demander la suppression de vos données.',
    rightPortTitle: 'Droit à la portabilité',
    rightPortDesc: 'Vous pouvez recevoir vos données dans un format structuré et les transférer.',
    rightOpposeTitle: 'Droit d\'opposition',
    rightOpposeDesc: 'Vous pouvez vous opposer au traitement dans certaines circonstances.',
    rightWithdrawTitle: 'Retrait du consentement',
    rightWithdrawDesc: 'Vous pouvez retirer votre consentement à tout moment.',
    rightsHowLabel: 'Comment exercer vos droits ?',
    rightsHowDesc: 'Pour exercer ces droits, contactez-nous via les informations de la section "Contact".',
    faqTitle: 'Questions fréquentes sur la confidentialité',
    faqSubtitle: 'Réponses claires à vos questions courantes.',
    faq1Q: 'Quelles données personnelles Punto Hispano collecte-t-il ?',
    faq1A: 'Nous collectons des données d\'identification, de contact, professionnelles et financières nécessaires à nos services, uniquement avec votre consentement.',
    faq2Q: 'Comment Punto Hispano protège-t-il mes données ?',
    faq2A: 'Nous utilisons des mesures techniques et administratives avancées, dont chiffrement AES-256, communications SSL/TLS et accès limité au personnel autorisé.',
    faq3Q: 'Puis-je demander la suppression de mes données ?',
    faq3A: 'Oui, vous pouvez demander la suppression de vos données lorsqu\'elles ne sont plus nécessaires, dans le respect des obligations légales.',
    faq4Q: 'Punto Hispano partage-t-il mes données avec des tiers ?',
    faq4A: 'Nous ne vendons pas vos données. Nous les partageons uniquement avec des prestataires de confiance, pour des obligations légales ou avec votre consentement explicite.',
    changesTitle: 'Modifications de cette Politique',
    changesP1: 'Nous pouvons mettre à jour cette Politique pour refléter des changements dans nos pratiques ou la réglementation.',
    changesNotifyLabel: 'Nous vous notifierons :',
    changesNotifyDesc: 'Tout changement important sera publié sur notre site avec mise à jour de la date "dernière mise à jour".',
    contactTitle: 'Des questions sur la confidentialité ?',
    contactIntro: 'Pour toute question ou préoccupation concernant cette Politique ou le traitement de vos données, contactez-nous :',
    contactCompanyLabel: 'Entreprise :',
    contactCompanyValue: 'Punto Hispano',
    contactAddressLabel: 'Adresse :',
    contactEmailLabel: 'Email :',
    contactPhoneLabel: 'Téléphone :',
    lastUpdated: 'Dernière mise à jour :',
    lastUpdatedDate: '24 juin 2025',
    lastUpdateNote: 'Cette politique peut être modifiée pour refléter des changements de pratiques ou de réglementation',
  },
  politicaCookiesPage: {
    seoTitle: 'Politique de Cookies | Punto Hispano',
    seoDesc: 'Informations sur les cookies que nous utilisons et comment gérer vos préférences.',
    title: 'Politique de Cookies',
    subtitle: 'Transparence totale sur notre utilisation des cookies',
    whatAreCookies: 'Que sont les cookies et pourquoi les utilisons-nous ?',
    whatAreCookiesP1: 'Les cookies sont de petits fichiers texte enregistrés sur votre appareil lorsque vous visitez notre site web. Ils sont totalement sûrs et nous aident à vous offrir une meilleure expérience.',
    whatAreCookiesP2: 'Chez Punto Hispano, nous utilisons les cookies de manière responsable et transparente, en conformité avec la réglementation européenne.',
    cookieTypes: 'Quels types de cookies utilisons-nous ?',
    essentialTitle: 'Cookies essentiels ou nécessaires',
    essentialWhat: 'Que font-ils ?',
    essentialWhatDesc: 'Ils sont indispensables au bon fonctionnement de notre site web.',
    essentialWhy: 'Pourquoi en avons-nous besoin ?',
    essentialWhyDesc: 'Ils permettent la navigation, l\'accès aux zones sécurisées et les fonctionnalités de base.',
    essentialNote: 'Ces cookies ne nécessitent pas votre consentement car ils sont techniquement nécessaires.',
    preferencesTitle: 'Cookies de préférences',
    preferencesWhatDesc: 'Ils mémorisent vos préférences pour personnaliser votre expérience.',
    preferencesExamples: 'Langue sélectionnée, paramètres d\'accessibilité, préférences de navigation.',
    preferencesNote: 'Ils améliorent votre expérience mais ne sont pas indispensables.',
    analyticsTitle: 'Cookies statistiques ou analytiques',
    analyticsWhatDesc: 'Ils nous aident à comprendre comment vous utilisez notre site de manière anonyme.',
    analyticsWhyDesc: 'Nous améliorons constamment nos services sur la base de données d\'utilisation réelles.',
    analyticsNote: 'Les données sont traitées de manière anonyme et agrégée.',
    marketingTitle: 'Cookies marketing',
    marketingWhatDesc: 'Ils nous permettent de vous montrer du contenu et des offres plus pertinents.',
    marketingHowDesc: 'Ils suivent votre comportement de navigation pour personnaliser l\'expérience.',
    marketingNote: 'Vous pouvez toujours désactiver ces cookies sans affecter le fonctionnement du site.',
    specificCookies: 'Cookies spécifiques que nous utilisons',
    tableName: 'Nom',
    tableProvider: 'Fournisseur',
    tablePurpose: 'Objectif',
    tableDuration: 'Durée',
    tableType: 'Type',
    controlTitle: 'Comment contrôler les cookies ?',
    controlDesc: 'Vous avez le contrôle total. Vous pouvez les accepter, les refuser ou les configurer.',
    onOurSite: 'Sur notre site web',
    onOurSiteDesc: 'Lors de votre première visite, une bannière apparaît où vous pouvez :',
    onOurSiteItems: ['Accepter tous les cookies', 'Refuser les non-essentiels', 'Configurer vos préférences en détail'],
    inBrowser: 'Dans votre navigateur',
    inBrowserDesc: 'Vous pouvez également gérer les cookies depuis votre navigateur :',
    inBrowserItems: ['Bloquer tous les cookies', 'Supprimer les cookies existants', 'Configurer des exceptions par site web'],
    browserSettings: 'Paramètres du navigateur',
    thirdPartyCookies: 'Cookies tiers',
    thirdPartyWarning: 'Certains services externes (comme Google Analytics) peuvent installer leurs propres cookies.',
    thirdPartyDesc: 'Nous nous assurons que :',
    thirdPartyItems: ['Nous travaillons uniquement avec des fournisseurs respectueux de la vie privée', 'Les données sont traitées de manière anonyme', 'Ils sont conformes à la réglementation européenne', 'Vous pouvez les désactiver si vous le souhaitez'],
    changesTitle: 'Modifications de notre Politique de Cookies',
    changesDesc: 'Nous pouvons mettre à jour cette politique occasionnellement.',
    changesNotice: 'Tout changement important sera clairement communiqué sur notre site web.',
    questionsTitle: 'Des questions sur les cookies ?',
    questionsDesc: 'N\'hésitez pas à nous contacter :',
    lastUpdated: 'Dernière mise à jour :',
    lastUpdatedDate: '24 juin 2025',
  },
  politicaGdprPage: {
    seoTitle: 'Politique RGPD | Protection des Données Personnelles | Punto Hispano',
    seoDesc: 'Politique de protection des données personnelles selon le RGPD. Connaissez vos droits et comment nous traitons vos informations.',
    title: 'Protection des Données Personnelles',
    subtitle: 'Votre vie privée est notre priorité — Connaissez vos droits selon le RGPD',
    whyImportant: 'Pourquoi votre vie privée est-elle importante ?',
    whyImportantP1: 'Chez Punto Hispano, nous traitons vos informations personnelles avec le plus grand respect et la plus grande transparence. Nous respectons le RGPD et la Loi fédérale suisse sur la protection des données.',
    whyImportantP2: 'Cette politique vous explique de manière simple quelles données nous collectons, comment nous les utilisons et quels sont vos droits.',
    whoResponsible: 'Qui est responsable de vos données ?',
    whoResponsibleDesc: 'Punto Hispano Holding est l\'entreprise responsable du traitement de vos données personnelles.',
    ourAddress: 'Notre adresse :',
    phoneLabel: 'Téléphone :',
    emailGeneralLabel: 'Email général :',
    whatData: 'Quelles informations collectons-nous ?',
    whatDataIntro: 'Nous ne collectons que les informations nécessaires pour vous offrir nos services professionnels. La quantité et le type de données dépendent du service demandé.',
    data1Title: '1. Données d\'identification de base',
    data1What: 'Ce que cela comprend :',
    data1WhatDesc: 'Nom complet, pièce d\'identité, date de naissance, nationalité.',
    data1Why: 'Pourquoi nous en avons besoin :',
    data1WhyDesc: 'Essentielles pour fournir des services juridiques et administratifs en Suisse.',
    data2Title: '2. Informations de contact',
    data2WhatDesc: 'Adresse postale, téléphones, email, contact d\'urgence.',
    data2WhyDesc: 'Pour communiquer avec vous et envoyer des documents importants.',
    data3Title: '3. Données professionnelles et financières',
    data3WhatDesc: 'Situation professionnelle, entreprise, revenus, documents fiscaux.',
    data3WhyDesc: 'Pour les démarches administratives, fiscales et d\'assurance.',
    data4Title: '4. Données spéciales (uniquement avec votre accord)',
    data4Important: 'Important :',
    data4ImportantDesc: 'Nous ne traitons les données sensibles qu\'avec votre consentement exprès.',
    data4WhatDesc: 'État civil, données de santé (pour assurance médicale), informations bancaires.',
    data4Control: 'Votre contrôle :',
    data4ControlDesc: 'Vous pouvez retirer ce consentement à tout moment.',
    rightsTitle: 'Quels sont vos droits ?',
    rightsIntro: 'En tant que titulaire de données personnelles, vous avez des droits importants que vous pouvez exercer à tout moment :',
    right1Title: 'Droit de savoir',
    right1Desc: 'Vous pouvez demander des informations sur les données détenues, leur utilisation et leur partage.',
    right2Title: 'Droit de rectification',
    right2Desc: 'En cas de données incorrectes ou incomplètes, vous pouvez demander une correction immédiate.',
    right3Title: 'Droit à l\'oubli',
    right3Desc: 'Vous pouvez demander la suppression de vos données lorsqu\'elles ne sont plus nécessaires (en respectant les obligations légales).',
    right4Title: 'Droit à la portabilité',
    right4Desc: 'Vous pouvez recevoir vos données au format numérique pour les transférer à un autre prestataire.',
    howExercise: 'Comment exercer vos droits ?',
    howExerciseIntro: 'C\'est très simple. Vous pouvez nous contacter par l\'un de ces moyens :',
    byEmail: 'Par email',
    byEmailWrite: 'Écrivez à :',
    byEmailNote: 'Joignez une copie de votre pièce d\'identité',
    byPhone: 'Par téléphone',
    byPhoneCall: 'Appelez :',
    byPhoneNote: 'Heures de bureau',
    inPerson: 'En personne',
    inPersonVisit: 'Visitez nos bureaux',
    inPersonNote: 'Demandez un rendez-vous',
    responseTime: 'Délai de réponse :',
    responseTimeDesc: 'Nous répondons sous 30 jours maximum. Pour les cas complexes, jusqu\'à 60 jours, mais nous vous préviendrons.',
    howProtect: 'Comment protégeons-nous vos informations ?',
    securityMeasures: 'Mesures de sécurité',
    securityIntro: 'Nous mettons en œuvre les meilleures mesures techniques pour protéger vos données :',
    security1: 'Chiffrement AES-256 pour le stockage',
    security2: 'Communications sécurisées SSL/TLS',
    security3: 'Accès restreint au personnel autorisé',
    security4: 'Sauvegardes chiffrées',
    security5: 'Formation régulière de l\'équipe en protection des données',
    retention: 'Combien de temps conservons-nous vos données ?',
    retentionIntro: 'Nous ne conservons vos informations que le temps nécessaire :',
    retention1Label: 'Documents fiscaux :',
    retention1Desc: '10 ans (loi suisse)',
    retention2Label: 'Marketing :',
    retention2Desc: 'Jusqu\'au retrait du consentement',
    retention3Label: 'Communications :',
    retention3Desc: '3 ans depuis la dernière interaction',
    retention4Label: 'Données web :',
    retention4Desc: 'Maximum 2 ans',
    international: 'Transferts internationaux',
    internationalDesc: 'Si nous devons transférer des données hors d\'Europe, nous le faisons uniquement vers des pays à protection adéquate (comme l\'Espagne) ou des prestataires certifiés aux États-Unis.',
    questionsTitle: 'Des questions ou des plaintes ?',
    questionsIntro: 'Pour toute question sur cette politique ou sur le traitement de vos données, contactez notre Délégué à la Protection des Données :',
    emailLabel: 'Email :',
    complaintLabel: 'Droit de réclamation :',
    complaintDesc: 'Si vous estimez que nous ne respectons pas la réglementation, vous pouvez déposer une plainte auprès du Préposé fédéral suisse à la protection des données (PFPDT) ou de l\'autorité de votre pays.',
    lastUpdated: 'Dernière mise à jour :',
    lastUpdatedDate: '24 juin 2025',
    updateNote: 'Nous vous notifierons tout changement important de cette politique',
  },
  heroHome: {
    titleLine1: 'Arrêtez de survivre.',
    titleLine2: 'Commencez à vivre en Suisse.',
    subtitle: 'Nous savons ce que c\'est que d\'être perdu dans les démarches. Retrouvez votre tranquillité : nous nous occupons de tout.',
    cta: 'Découvrez nos solutions',
    statFamilies: 'Familles sereines',
    statFamiliesDesc: 'Ont résolu leurs démarches',
    statYears: 'Années d\'expérience',
    statYearsDesc: 'Des problèmes réels comme le vôtre',
    statAvailable: 'Toujours disponibles',
    statAvailableDesc: 'Quand vous avez besoin de nous',
    statSolutions: 'Solutions',
    statSolutionsDesc: 'Pour chaque problème',
  },
  footerLinks: {
    servicios: 'Services', gestoria: 'Gestion', lifestyle: 'Lifestyle', empresa: 'Entreprise', legal: 'Juridique',
    gestoriaAdmin: 'Gestion & Administration', asesoriaLegal: 'Conseil Juridique', formacionIdiomas: 'Formation Linguistique', segurosPensiones: 'Assurances & Prévoyance',
    desempleoRav: 'Chômage (ORP)', administracion: 'Administration', cvDoc: 'CV & Documents', acompanamientos: 'Accompagnements', traducciones: 'Traductions', paquetes: 'Packs Spéciaux',
    vehiculos: 'Location de Véhicules', viviendas: 'Location de Logements', packRelocation: 'Pack Relocation', solucionesDigitales: 'Solutions Numériques',
    sobreNosotros: 'À Propos', blog: 'Blog', contacto: 'Contact', zonasServicio: 'Zones de Service',
    privacidad: 'Politique de Confidentialité', avisoLegal: 'Mentions Légales', cookies: 'Politique de Cookies', gdpr: 'RGPD',
    invalidEmail: 'E-mail invalide', errorRetry: 'Erreur. Veuillez réessayer.', followUs: 'Suivez-nous sur',
  },
  navbar: {
    tagline: 'Votre gestion & conseil en', contactUs: 'Contactez-nous', closeMenu: 'Fermer le menu', openMenu: 'Ouvrir le menu',
    myProfile: 'Mon Profil', logout: 'Déconnexion', login: 'Connexion',
  },
  cart: {
    title: 'Votre Panier', emptyCart: 'Votre panier est vide', service: 'service', services: 'services', selected: 'sélectionnés', clearCart: 'Vider le panier',
    limitedOffer: 'Offre Limitée !', addMoreServices: 'Ajoutez plus de services et obtenez des remises exclusives',
    numberOfPeople: 'Nombre de personnes :', couponPlaceholder: 'Code promo', apply: 'Appliquer',
    subtotal: 'Sous-total :', persons: 'personnes :', discount: 'Remise :', total: 'Total :', continue: 'Continuer', backToCart: '← Retour au panier',
    couponInvalid: 'Coupon invalide ou expiré', couponExpired: 'Ce coupon a expiré', couponMaxUses: 'Ce coupon a atteint sa limite d\'utilisation',
    couponMinPurchase: 'Achat minimum de {amount} CHF requis', couponApplied: 'Coupon appliqué !', couponDiscount: 'Remise de {discount}',
    couponRemoved: 'Coupon supprimé', couponRemovedDesc: 'La remise a été supprimée', couponError: 'Erreur de validation du coupon',
    serviceRemoved: 'Service supprimé', serviceRemovedDesc: '"{title}" a été retiré du panier',
    paymentMigration: 'Paiements en migration', paymentMigrationDesc: 'Nous migrons ce checkout. Contactez-nous pour finaliser votre demande.',
    paymentError: 'Impossible de continuer', paymentErrorDesc: 'Veuillez réessayer dans un instant',
  },
  contactForm: {
    fullName: 'Nom complet', email: 'E-mail', phone: 'Téléphone', serviceArea: 'Domaine de service', selectService: 'Sélectionner un service',
    message: 'Message', messagePlaceholder: 'Décrivez votre demande ou projet...', characters: 'caractères',
    send: 'Envoyer le message', sending: 'Envoi en cours...', formErrors: 'Erreurs dans le formulaire :', formErrorsDesc: 'Veuillez corriger les erreurs indiquées.',
    tooManyAttempts: 'Trop de tentatives. Réessayez dans {seconds} secondes.', submitError: 'Erreur d\'envoi. Veuillez réessayer.',
    successTitle: 'Message envoyé', successDesc: 'Merci de nous avoir contactés. Nous répondrons bientôt.',
    errorTitle: 'Erreur', errorDesc: 'Erreur lors de l\'envoi du message.',
    gestoriaOption: 'Gestion & Administration', legalOption: 'Conseil Juridique', segurosOption: 'Assurances & Prévoyance',
    idiomasOption: 'Cours de Langues', digitalOption: 'Services Numériques', webOption: 'Conception Web', crmOption: 'CRM',
    iaOption: 'Intelligence Artificielle', automationOption: 'Automatisation', devOption: 'Développement Sur Mesure', generalOption: 'Demande Générale',
    namePlaceholder: 'Votre nom complet',
  },
  categoryHero: { requestInfo: 'Demander des informations', meetTeam: 'Rencontrez notre équipe' },
  gestoriaCategoryPage: {
    specializedAgency: 'Gestion Spécialisée', professionalService: 'Service professionnel en espagnol pour les hispanophones en Suisse.',
    freeConsultation: 'Consultation Gratuite', callNow: 'Appeler Maintenant',
    clientsServed: 'Clients servis', fastResponse: 'Réponse rapide', inSpanish: 'En espagnol', averageRating: 'Note moyenne',
    servicesOf: 'Services de', finalPrices: 'Tous les prix sont définitifs. Pas de coûts cachés.', popular: 'Populaire', add: 'Ajouter', consult: 'Consulter',
    freeOrConsult: 'Gratuit ou à consulter', freeOrConsultDesc: 'Contactez-nous pour plus d\'informations.',
    addedToCart: 'Ajouté au panier',
    howItWorks: 'Comment ça marche ?', step1: 'Contact', step1Desc: 'Dites-nous votre situation par WhatsApp ou téléphone',
    step2: 'Documentation', step2Desc: 'Nous rassemblons toute la documentation nécessaire', step3: 'Gestion', step3Desc: 'Nous effectuons toutes les démarches pour vous',
    step4: 'Résultat', step4Desc: 'Nous vous remettons tout terminé et expliqué',
    needHelp: 'Besoin d\'aide avec', firstFree: 'Première consultation gratuite. Sans engagement.', whatsapp: 'WhatsApp',
  },
  categoryFaq: { defaultTitle: 'Questions fréquentes' },
  categoryBlog: { defaultTitle: 'Articles connexes', viewAll: 'Voir tous les articles', readMore: 'Lire la suite' },
  categoryContact: {
    defaultTitle: 'Contactez nos experts', defaultDesc: 'Demandez des informations ou un devis personnalisé',
    preferDirect: 'Préférez-vous parler directement ?', teamAvailable: 'Notre équipe est disponible pour répondre à toutes vos questions par WhatsApp ou planifier un appel.',
    formSent: 'Formulaire envoyé !', formSentDesc: 'Merci de nous avoir contactés. Un membre de notre équipe vous recontactera dès que possible.',
    sendAnother: 'Envoyer un autre message', name: 'Nom', namePlaceholder: 'Votre nom complet', email: 'E-mail',
    phoneOptional: 'Téléphone (optionnel)', serviceArea: 'Domaine de service', selectService: 'Sélectionner un service',
    message: 'Message', messagePlaceholder: 'Décrivez votre demande en détail', sending: 'Envoi en cours...', send: 'Envoyer le message',
    successTitle: 'Formulaire envoyé avec succès', successDesc: 'Nous vous contacterons dès que possible',
  },
  writeReview: {
    title: 'Écrire un avis', whereToWrite: 'Où souhaitez-vous écrire votre avis ?',
    googleReview: 'Avis Google', googleDesc: 'Public, apparaît sur Google Maps',
    websiteReview: 'Avis sur notre site', websiteDesc: 'Apparaît sur notre site après vérification',
    recommendGoogle: 'Nous recommandons aussi d\'écrire sur Google pour une visibilité maximale',
    redirectGoogle: 'Redirection vers Google', redirectGoogleDesc: 'Vous serez redirigé vers Google Maps.',
    goToGoogle: 'Aller sur Google Maps', goBack: 'Retour',
    nameLabel: 'Nom *', emailLabel: 'E-mail *', ratingLabel: 'Note *', starsOf: 'sur 5 étoiles',
    serviceUsed: 'Service utilisé', selectServicePlaceholder: 'Sélectionner le service',
    reviewTitle: 'Titre de l\'avis', reviewTitlePlaceholder: 'Résumé de votre expérience',
    yourReview: 'Votre avis *', yourReviewPlaceholder: 'Parlez-nous de votre expérience...',
    submitReview: 'Envoyer l\'avis', submitting: 'Envoi en cours...',
    reviewNote: '* Votre avis sera vérifié avant publication.',
    requiredFields: 'Champs requis', requiredFieldsDesc: 'Veuillez remplir tous les champs obligatoires.',
    reviewSent: 'Avis envoyé !', reviewSentDesc: 'Votre avis sera vérifié avant publication. Merci !',
    reviewError: 'Impossible d\'envoyer l\'avis. Veuillez réessayer.',
    gestoria: 'Gestion', legal: 'Conseil Juridique', seguros: 'Assurances', idiomas: 'Formation Linguistique',
    web: 'Développement Web', crm: 'CRM & Automatisation', general: 'Demande Générale',
  },
  blogNewsletter: {
    welcomeTitle: 'Bienvenue dans notre communauté !', welcomeDesc: 'Vous recevrez nos meilleurs contenus et conseils exclusifs',
    title: 'Newsletter Exclusive pour Hispanophones', subtitle: 'Recevez chaque semaine des guides pratiques et des conseils juridiques',
    exclusive: 'Contenu Exclusif', exclusiveDesc: 'Guides non disponibles sur le blog',
    legalUpdates: 'Mises à jour Juridiques', legalUpdatesDesc: 'Changements fiscaux et légaux en Suisse',
    weeklyTips: 'Conseils Hebdomadaires', weeklyTipsDesc: 'Conseils pratiques chaque semaine',
    namePlaceholder: 'Votre nom (optionnel)', subscribing: 'Inscription...', subscribe: 'S\'abonner Gratuitement',
    noSpam: 'Pas de spam. Vous pouvez vous désabonner à tout moment.',
    invalidEmail: 'E-mail invalide', invalidEmailDesc: 'Veuillez entrer un e-mail valide',
    successTitle: 'Inscription réussie !', successDesc: 'Nous vous avons envoyé un e-mail de confirmation',
    errorTitle: 'Erreur', errorDesc: 'Problème avec l\'inscription. Veuillez réessayer.',
  },
  exitIntent: {
    defaultTitle: 'Attendez ! Nous avons quelque chose pour vous', defaultDesc: 'Avant de partir, laissez votre e-mail et recevez une consultation gratuite de 10 minutes',
    defaultOffer: 'Consultation gratuite', submit: 'Je veux ma consultation gratuite',
    sending: 'Envoi en cours...', thanks: 'Merci ! Nous vous contacterons bientôt',
    error: 'Erreur d\'envoi. Veuillez réessayer', dismiss: 'Non merci, continuer la navigation',
  },
  contactInline: {
    nameFull: 'Nom complet', namePlaceholder: 'Votre nom', email: 'E-mail',
    phoneOptional: 'Téléphone (optionnel)', serviceInterest: 'Service qui vous intéresse',
    selectService: 'Sélectionner un service', gestoria: 'Gestion & Administration', legal: 'Conseil Juridique',
    idiomas: 'Formation Linguistique', seguros: 'Assurances & Prévoyance', digital: 'Solutions Numériques',
    coches: 'Location de Voitures', viviendas: 'Location de Logements', relocation: 'Pack Relocation',
    orientacion: 'Pas sûr(e) — j\'ai besoin d\'orientation',
    whatWorries: 'Qu\'est-ce qui vous préoccupe ?', tellUs: 'Décrivez brièvement votre situation...',
    sending: 'Envoi en cours...', sendFree: 'Envoyer ma Demande Gratuite',
    dataPrivacy: '🔒 Vos données sont confidentielles. Nous ne partageons pas vos informations.',
    sentTitle: 'Message Envoyé !', sentDesc: 'Nous répondons dans un maximum de 2 heures.',
    sendAnother: 'Envoyer un autre message', successTitle: 'Message envoyé !', successDesc: 'Nous répondons en moins de 2 heures.',
    errorTitle: 'Erreur d\'envoi', errorDesc: 'Un problème est survenu. Veuillez réessayer.',
  },
  homeFeatured: {
    kicker: 'Services en vedette', deliveredThisYear: 'services fournis cette année',
    title: 'Services professionnels en Suisse pour hispanophones',
    subtitle: 'Gestion, conseil juridique et transformation numérique, tout dans votre langue',
    desc: 'Optimisez vos impôts, régularisez votre situation et développez votre entreprise',
    viewAll: 'Voir Tous les Services',
    gestoria: 'Gestion Fiscale', gestoriaDesc: 'Conseil fiscal personnalisé pour particuliers et entreprises.',
    gestoriaBtn: 'Voir les services de gestion',
    legal: 'Conseil Juridique', legalDesc: 'Service juridique spécialisé pour la communauté hispanophone.',
    legalBtn: 'Voir les services juridiques',
    digital: 'Solutions Numériques', digitalDesc: 'Transformation numérique pour développer votre entreprise.',
    digitalBtn: 'Voir les solutions numériques',
    feat1: 'Déclarations d\'impôts', feat2: 'Planification fiscale', feat3: 'Comptabilité', feat4: 'Optimisation fiscale',
    feat5: 'Immigration & résidence', feat6: 'Contrats de travail', feat7: 'Droit de la famille', feat8: 'Conseil immobilier',
    feat9: 'Conception web professionnelle', feat10: 'Systèmes CRM personnalisés', feat11: 'Automatisation des processus', feat12: 'Marketing numérique efficace',
  },
  homeStats: {
    title: 'Des résultats qui inspirent confiance', updated: 'Mis à jour 2025',
    clients: 'Clients Satisfaits', clientsDesc: 'Nous ont fait confiance',
    procedures: 'Démarches Complétées', proceduresDesc: 'Résolution réussie',
    companies: 'Entreprises Créées', companiesDesc: 'Dans toute la Suisse',
    experience: 'Années d\'Expérience', experienceDesc: 'Service continu',
  },
  homeTestimonials: {
    title: 'Ce que Disent nos Clients', subtitle: 'Avis réels de clients satisfaits',
    basedOn: 'Basé sur 50+ avis Google', verified: 'Vérifié', googleReview: 'Avis Google',
    viewAll: 'Voir tous les avis', leaveReview: 'Laissez-nous un avis',
    usedServices: 'Avez-vous utilisé nos services ? Votre avis est très important pour nous.',
  },
  serviciosSection: {
    title: 'Services', titleAccent: 'clés pour votre vie en Suisse',
    subtitle: 'Tout en un seul endroit, sans barrières linguistiques.',
    gestoria: 'Gestion & Administration', gestoriaDesc: 'Impôts et comptabilité sans complications.',
    legal: 'Conseil Juridique', legalDesc: 'Immigration, travail et famille avec des avocats bilingues.',
    idiomas: 'Cours d\'Allemand', idiomasDesc: 'Progressez dès la première semaine.',
    seguros: 'Assurances & 3ème Pilier', segurosDesc: 'Comparaison indépendante. Économies réelles.',
    digital: 'Solutions Numériques', digitalDesc: 'Web + CRM + IA pour grandir en Suisse.',
    coches: 'Location de Voitures', cochesDesc: 'Livraison flexible, tous risques, en espagnol.',
    viviendas: 'Location de Logements', viviendasDesc: 'Nous organisons les visites, vous choisissez.',
    relocation: 'Pack Relocation', relocationDesc: 'Vous arrivez et nous résolvons tout en 30 jours.',
    bestSeller: 'Best-seller 🔥', forHispanics: 'Pour hispanophones', save25: 'Économisez jusqu\'à 25%', allInclusive: 'Tout inclus ✅',
    learnMore: 'En savoir plus', customSolution: 'Besoin d\'une solution personnalisée ?',
    customDesc: 'Contactez nos experts pour une consultation gratuite.',
    enterBtn: 'Accéder', creating: 'Création du compte...', createBtn: 'Créer un compte',
    trustClients: 'Clients satisfaits', trustResponse: 'Temps de réponse', trustResponseValue: '< 2 heures',
    trustLanguages: 'Langues', trustLanguagesValue: 'ES, DE, EN',
  },
  resetPassword: {
    seoTitle: 'Nouveau Mot de Passe - Punto Hispano', seoDesc: 'Définir votre nouveau mot de passe',
    successSeoTitle: 'Mot de Passe Mis à Jour', successSeoDesc: 'Votre mot de passe a été mis à jour',
    invalidLink: 'Lien invalide ou expiré', invalidLinkDesc: 'Veuillez demander un nouveau lien',
    passwordMin: 'Le mot de passe doit avoir au moins 8 caractères',
    mismatch: 'Les mots de passe ne correspondent pas', mismatchDesc: 'Veuillez vérifier les deux mots de passe',
    tooShort: 'Mot de passe trop court', tooShortDesc: 'Minimum 8 caractères',
    successTitle: 'Mot de passe mis à jour !', successDesc: 'Votre mot de passe a été changé avec succès',
    successRedirect: 'Mot de passe changé avec succès. Redirection automatique...',
    goToClient: 'Aller à l\'espace client', newPassword: 'Nouveau Mot de Passe', enterNew: 'Entrez votre nouveau mot de passe',
    newPasswordLabel: 'Nouveau mot de passe', minChars: 'Minimum 8 caractères',
    confirmPassword: 'Confirmer le mot de passe', repeatPassword: 'Répéter le mot de passe',
    updating: 'Mise à jour...', changePassword: 'Changer le mot de passe',
    errorTitle: 'Erreur de changement', errorDesc: 'Problème lors du changement de mot de passe',
  },

  contactFormPage: {
    seoTitle: 'Formulaire de Contact | Punto Hispano',
    seoDesc: 'Contactez-nous pour des renseignements sur nos services pour la communauté hispanophone en Suisse.',
    title: 'Formulaire de Contact',
    subtitle: 'Remplissez le formulaire ci-dessous pour nous envoyer votre demande. Notre équipe vous répondra dans les plus brefs délais.',
    successTitle: 'Message envoyé !',
    successDesc: 'Merci de nous avoir contactés. Nous avons bien reçu votre message et nous vous répondrons dans un délai de 24 à 48 heures ouvrables.',
    sendAnother: 'Envoyer un autre message',
    labelName: 'Nom complet',
    placeholderName: 'Entrez votre nom',
    labelEmail: 'Adresse e-mail',
    placeholderEmail: 'nom@exemple.com',
    labelPhone: 'Téléphone (optionnel)',
    placeholderPhone: 'Votre numéro de téléphone',
    labelServiceArea: 'Domaine de service',
    selectArea: 'Sélectionnez un domaine',
    optGestoria: 'Gestion et Administration',
    optLegal: 'Conseil Juridique',
    optIdiomas: 'Formation en Langues',
    optSeguros: 'Assurances et Pensions',
    optDigital: 'Solutions Numériques',
    optCoches: 'Location de Voitures',
    optViviendas: 'Location de Logements',
    labelMessage: 'Message',
    placeholderMessage: 'Comment pouvons-nous vous aider ?',
    submitBtn: 'Envoyer le Message',
    sending: 'Envoi en cours...',
    toastSuccess: 'Formulaire envoyé',
    toastSuccessDesc: 'Nous avons reçu votre message et nous vous contacterons bientôt.',
    toastError: "Erreur d'envoi",
    toastErrorDesc: "Un problème est survenu lors de l'envoi. Veuillez réessayer.",
    privacyNote: 'En soumettant ce formulaire, vous acceptez notre',
    privacyLink: 'politique de confidentialité',
    privacyNote2: 'et le traitement de vos données pour répondre à votre demande.',
    fastResponse: 'Réponse rapide',
    fastResponseDesc: '24-48h ouvrables',
    noCommitment: 'Sans engagement',
    noCommitmentDesc: 'Devis personnalisés',
    spanishSupport: 'Service en espagnol',
    spanishSupportDesc: 'Équipe 100% hispanophone',
    validationName: 'Le nom doit comporter au moins 2 caractères',
    validationEmail: 'Veuillez entrer une adresse e-mail valide',
    validationService: 'Veuillez sélectionner un domaine de service',
    validationMessage: 'Le message doit comporter au moins 10 caractères',
    interestedIn: 'Je suis intéressé par les informations sur les services de',
  },

  serviceTemplates: {
    freeWhatsapp: 'Consultation Gratuite par WhatsApp',
    askWhatsapp: 'Demander des Informations par WhatsApp',
    whatsappDirect: 'WhatsApp Direct',
    notSure: 'Pas sûr de ce dont vous avez besoin ? Écrivez-nous — nous vous orientons gratuitement.',
    backTo: 'Retour à',
    popular: 'Populaire',
    bestSeller: 'Plus Vendu',
    allIncluded: 'Tout Inclus',
    free: 'Gratuit',
    servicesAvailable: 'services disponibles',
    serviceAvailable: 'service disponible',
    packagesAvailable: 'packs disponibles',
    packageAvailable: 'pack disponible',
    whichForYou: 'Lequel est fait pour vous ?',
    freeConsultation: 'Consultation Gratuite par WhatsApp',
    gestoriaBreadcrumb: 'Gestion Administrative',
    legalBreadcrumb: 'Conseil Juridique',
    legalFreeConsult: 'Consultation Gratuite par WhatsApp',
    legalNotSure: 'Pas sûr de ce dont vous avez besoin ? Nous vous orientons gratuitement.',
    segurosBreadcrumb: 'Assurances & Prévoyance',
    segurosInsured: '+20 000 personnes assurées en 5 ans',
    relocationBreadcrumb: 'Pack Relocation',
    relocationNeedHelp: 'Bonjour, j\'ai besoin d\'orientation sur le Pack Relocation.',
  },
  cookieBanner: {
    title: 'Cookies',
    description: 'Nous utilisons des cookies pour améliorer votre expérience.',
    moreInfo: 'Plus d\'infos',
    adjust: 'Personnaliser',
    reject: 'Refuser',
    accept: 'Accepter',
    preferences: 'Préférences',
    necessary: 'Nécessaires',
    functional: 'Fonctionnels',
    analytics: 'Analytiques',
    marketing: 'Marketing',
    required: 'requis',
    onlyNecessary: 'Uniquement nécessaires',
    save: 'Enregistrer',
  },
  sectionNav: {
    home: 'Accueil',
    services: 'Services',
    about: 'À propos',
    process: 'Processus',
    testimonials: 'Témoignages',
    faq: 'FAQ',
    contact: 'Contact',
  },
  helpWidget: {
    help: 'Besoin d\'aide ?',
    assistant: 'Assistant',
    minimize: 'Minimiser le widget d\'aide',
    howCanWeHelp: 'COMMENT POUVONS-NOUS VOUS AIDER ?',
    online: 'Nous sommes en ligne',
    closeMenu: 'Fermer le menu d\'aide',
    aiChat: 'CHAT IA',
    aiChatDesc: 'Réponse instantanée 24/7',
  },
};

export default fr;
